import { size } from 'underscore';

export default {
  message: {
    abm: {
      folders: {
        errors: {
          '10001': 'idCarpeta es un valor requerido',
          '10002': 'idCarpeta no es un valor entero válido',
          '10003': 'nombre es un valor requerido',
          '10004': 'nombre no es un valor alfanumérico válido',
          '10005': 'tipo es un valor requerido',
          '10006': 'tipo no es un valor alfanumérico válido',
          '10007': 'visible es un valor requerido',
          '10008': 'visible no tiene un valor booleano válido',
          '10009': 'firmable no tiene un valor booleano válido',
          '10010': 'efimero no tiene un valor booleano válido',
          '10011': 'El alias no es un valor alfanumérico válido',
          '10012': 'idTemplate no es un valor entero válido',
          '10013': 'sinCodigo no tiene un valor booleano válido',
          '10014': 'parser no es un valor alfabético válido',
          '10015': 'Hay una subcarpeta con ese nombre',
          '10016': 'Hay una subcarpeta con ese alias',
          '10017': 'template inválido',
          '10018': 'No hay una carpeta con ese id',
          '10019': 'idSubCarpeta is not a valid number',
          '10020': 'No hay una subcarpeta con ese id',
          '10021': 'Esta subcarpeta no se puede eliminar',
          '10022': 'No se puede modificar el valor del tipo',
          '10023': 'idTemplate es un valor requerido',
          '10024': 'No puede agregar un idTemplate con visible deshabilitado',
          '10025': 'Faltan parámetros',
          '10026': 'Los parámetros están vacíos',
          '10027': 'name no es un valor alfanumérico válido',
          '10028': 'Una o varias carpetas no pueden ser bloquedas',
          '10029': 'order no es un valor entero válido',
          '10030': 'El nombre de esta carpeta no se puede modificar',
          '10031': 'No puede ser efimero con firmable desactivado',
          '10032': 'No se puede bloquear con visible deshabilitado',
          '10033': 'name es un valor requerido',
          '10034': 'firmable es un valor requerido',
          '10035': 'efimero es un valor requerido',
          '10036': 'Ya existe una carpeta con este nombre en el sistema',
          '10037': 'No puede ser firmable con visible desactivado',
          '10038':
            'No se pudo eliminar la carpeta. La carpeta contiene documentos cargados.',
          '10039': 'No tiene posicionamiento de firma por default',
          '10040': 'Sin posicionamiento de firma para esta subcarpeta',
          '10041': 'El directorio no existe',
          '10042': 'No se pudo crear el pdf',
          '10043':
            'No se pudo agregar el archivo de posicionamiento de la firma',
          '10044': 'No se pudo crear la imagen en miniatura',
          '10045': 'No se pudo guardar en el storage',
          '10046': 'No se pudo eliminar el archivo de posición de la firma',
          '10047': 'No se pudo eliminar la posición de la firma',
          '10048': 'La paginación no es un valor de string válido',
          '10049': 'No se puede procesar el corte del PDF',
          '10050': 'El valor de rotacion es inválido',
          '10051': 'Archivo PDF no válido',
          '10052': 'El PDF supera el peso máximo de 5MB',
          '10053': 'La firma del colaborador es un valor requerido',
          '10054': 'Formato de firma del colaborador es inválido',
          '10055': 'Formato de firma del empleador es inválido',
          '10056': 'File es un valor requerido',
          '10057':
            'No puede editar este tipo de documento porque el identificador único no está definido correctamente. Comuniquese con soporte',
          '10058': 'No se pudo agregar el posicionamiento de la firma',
          '10059':
            'No es posible eliminar la carpeta, existen filtros por carpeta asociados a algunos usuarios',
          '10061': 'El parámetro sendIa es un valor requerido',
          '268': 'Este PDF se encuentra encriptado y no puede ser procesado',
          unknown: 'Error desconocido',
          SYSTEM_API_INVALID_PDF_FILE_SIZE:
            'El PDF supera el peso máximo de 5MB.',
          SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
            'El PDF supera el peso máximo de 5MB.',
          SYSTEM_API_WRONG_MIME_TYPE: 'El tipo soportado es archivos PDF.',
          NO_SUPPORTED:
            'El tamaño del PDF a cargar puede ser A3, A4, A5, Legal, Carta ó Minimo <span class="font-bold">147mm x 209mm</span> y Máximo <span class="font-bold">298mm x 421mm</span> ',
          THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE:
            'El tipo de documento {docName} ya tiene habilitada la opción de análisis por IA.',
          THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE_DESCRIPTION:
            'Este atributo únicamente puede estar disponible para un tipo de documento.'
        },
        modals: {
          cancelFolder: {
            title: 'Configuración de carpetas',
            label:
              '¿Estas seguro de que quieres salir de la configuración de carpeta?',
            label1:
              'Todos los cambios realizados en esta configuración seran descartados',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, salir'
          },
          cancelSubFolder: {
            title: 'Salir de la configuración de tipo documento',
            label: '¿Estás seguro de que quieres salir de la configuración de',
            label1: 'tipo de documento',
            label2:
              'Todos los cambios realizados en esta configuración serán descartados',
            label3:
              'Puedes continuar con la creación de documentos en cualquier momento',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, salir'
          },
          deleteFolder: {
            title: 'Eliminar carpeta',
            label: 'Estás seguro de querer eliminar la carpeta',
            label1: 'También se eliminarán los tipos de documentos asociados.',
            label2: 'Esta acción no se puede deshacer',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, eliminarla',
            buttonOk: 'Ok'
          },
          deleteSubFolder: {
            title: 'Eliminar tipo de documento',
            label: 'Estás seguro de querer eliminar',
            label1: ' Esta acción no se puede deshacer',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sí, eliminarlo',
            buttonOk: 'Ok',
            buttonDeletePrimary: 'Sí, eliminar',
          },
          deleteSubFolderConfig: {
            label:
              '¿Estás seguro de que quieres eliminar la configuración actual del documento?'
          },
          emailPreview: {
            title: 'Vista previa',
            label: 'Hola',
            label1:
              'Le informamos que cuenta con un nuevo documento pendiente por firmar en la bandeja de TuRecibo',
            label2: 'Ingresar al sistema',
            label3: 'Saludos',
            label4: 'Equipo de',
            label5:
              'NOTA: Favor no responder este mensaje que ha sido generado automáticamente desde TuRecibo. Esta comunicación (incluidos sus anexos) contiene información confidencial, dirigida exclusivamente a su destinatario, quien deberá resguardar la confidencialidad. Queda prohibido la divulgación, modificación, reproducción o uso de la información aquí contenida por cualquier otra persona que no sea su destinatario',
            buttonPrimary: 'Cerrar vista previa'
          },
          generic: {
            title: 'Configuración de carpetas',
            buttonPrimary: 'Entendido'
          },
          cancelSubFolderConfig: {
            cancelQuestion:
              '¿Desea aplicar los cambios antes de salir de la configuración del documento?',
            dismiss: 'Descartar',
            ok: 'Sí, aplicar'
          },
          confirmSubFolderConfig: {
            confirmQuestion:
              '¿Estás seguro de que quieres guardar los cambios realizados en el documento?',
            ok: 'Aceptar'
          }
        },
        settings: {
          folderName: {
            default: 'Nueva Carpeta',
            question: '¿Cúal es el nombre de esta carpeta?',
            description:
              'El nombre de la carpeta te va a servir para identificar los documentos que se guarden en la misma, trata de que sea un nombre descriptivo'
          },
          persistDocument: {
            question:
              '¿Los documentos permanecen en la bandeja de tu colaborador?',
            description:
              'Todos los documentos van a permanecer en la bandeja de entrada de tu colaborador para que los pueda visualizar, descargar e imprimirlos',
            option: {
              label: 'Visibles',
              legend:
                'Luego de firmarlo permanecen en la bandeja de tu colaborador'
            },
            option1: {
              label: 'Ocultarlos',
              legend:
                'Luego de firmarlo permanecen en la bandeja de tu colaborador'
            }
          },
          requiresSignature: {
            question: '¿Requiere firma del colaborador?',
            description:
              'Los documentos de esta carpeta van a aparecerle a tu colaborador en su bandeja de entrada para que lo pueda firmar',
            option: {
              label: 'Requiere firma'
            },
            option1: {
              label: 'No requiere firma'
            }
          },
          signaturePriority: {
            question: '¿Esta carpeta tiene prioridad para ser firmada?',
            question1: 'Selecciona la carpeta que tiene prioridad de firma',
            description:
              'El colaborador tiene que firmar primero los documentos de esta carpeta para luego continuar con el resto de los documentos',
            description1:
              'Esta carpeta es prioritaria y requiere firma del colaborador',
            option: {
              label: 'No tiene prioridad'
            },
            option1: {
              label: 'Si tiene prioridad'
            },
            select: 'Selecciona la carpeta',
            placeholder: 'Busca o selecciona del listado',
            selectLabel: 'Presione enter para seleccionar',
            selectGroupLabel: 'Presione enter para seleccionar el grupo',
            selectedLabel: 'Seleccionada',
            deselectLabel: 'Presione enter para eliminar',
            deselectGroupLabel:
              'Presione enter para anular la selección del grupo',
            noResult: 'No se encontraron resultados'
          },
          visibleDocuments: {
            question:
              '¿Los documentos son visibles en la bandeja de tu colaborador?',
            description:
              'Todos los documentos van a ser visibles en la bandeja de entrada de tu colaborador para que los pueda visualizar, descargar e imprimirlos',
            option: {
              label: 'Sí, son visibles',
              legend: 'Los documentos aparecen en la bandeja de tu colaborador'
            },
            option1: {
              label: 'No, ocultarlos',
              legend:
                'Los documentos no aparecen en la bandeja de tu colaborador'
            }
          },
          defaultPosition: {
            label: 'Puedes reemplazar este archivo desde',
            label1: 'subir pdf'
          },
          deleteSignature: {
            label: 'Eliminar firma',
            question:
              '¿Queres eliminar la firma que configuraste para esta carpeta?',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Si, eliminarla'
          },
          positionSignature: {
            question: '¿Como quieres posicionar la firma en el documento?',
            description:
              'Ubica en el documento el lugar donde van a impactar las firma que realice el colaborador',
            option: {
              label: 'No mostrar firma'
            },
            option1: {
              label: 'Mostrar firma'
            },
            label: 'Editar',
            label1: 'Establecer ubicación de firma'
          },
          signatureTools: {
            label: 'Utilizar pdf propio',
            label1: 'Subir pdf',
            label2: 'Eliminar pdf',
            label3: '¿Queres eliminar el pdf?',
            label4: 'Esta acción no se puede deshacer',
            label5: 'Página a firmar',
            label6: 'Primera',
            label7: 'Ultima',
            label8: 'Personalizar',
            label9: 'El numero de página es inexistente',
            label10: 'Orientación',
            label11: 'Vertical',
            label12: 'Horizontal',
            label13: 'Tamaño papel',
            label14: 'Formato',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Si, eliminar',
            buttonPrimary1: 'Aceptar'
          },
          documentIdentificator: {
            question:
              '¿Cómo quieres utilizar el identificador unico en el documento?',
            description:
              'Puedes seleccionar la forma de detectarlo en el documento, puede ser por el nombre del archivo o realizando un escaneo en la primera página dentro del documento'
          },
          alias: {
            question:
              '¿Quieres modificar el nombre del documento enviado por email?',
            description:
              'Puedes modificar el nombre del documento que recibe tu colaborador en su casilla de email para que sea mas facil la identificación del mismo',
            option: {
              label: 'Utilizar el nombre por defecto',
              legend: 'El nombre por defecto que tiene el documento'
            },
            option1: {
              label: 'Modificar el nombre del documento',
              legend: 'Cambiar el nombre del documento por otro mas descriptivo'
            },
            preview: 'Previsualizar email'
          },
          documentType: {
            question: '¿Este tipo de documento es un formulario digital?',
            option: {
              label: 'Sí'
            },
            option1: {
              label: 'No'
            }
          },
          documentXML: {
            question: '¿Se debe adjuntar documento XML?',
            option: {
              label: 'Sí'
            },
            option1: {
              label: 'No'
            }
          },
          loadDocument: {
            question: '¿El colaborador puede cargar este tipo de documentos?',
            question1: '¿Cuantas páginas de este documento son necesarias?',
            description:
              'Tu colaborador puede subir este tipo de documento a la plataforma para que lo puedas recibir y tomar acciones',
            description1:
              'Es necesario que selecciones la cantidad de páginas totales del documento y cuantas páginas del mismo son obligatorias',
            option: {
              label: 'No carga documentos',
              legend: 'El colaborador no puede subir este tipo de documentos'
            },
            option1: {
              label: 'Carga documentos',
              legend: 'El colaborador puede subir este tipo de documentos'
            }
          },
          subFolderName: {
            default: 'Tipo de documento',
            question: '¿Cúal es el nombre de este tipo de documento?',
            description:
              'El nombre del tipo de documento te va a servir para identificarlos, trata de que sea un nombre descriptivo',
            placeholder: 'El nombre del tipo de documento',
            configuration: {
              question: 'Configuración de documento',
              description:
                'Podras rotar, cortar el documento y establecer el posicionamiento de las firmas en el mismo.',
              label: 'Configurar',
              applied: 'Configuraciones aplicadas',
              deleteConfig: 'Eliminar configuración actual',
              notApplied: 'Este documento no tiene configuraciones aplicadas'
            }
          },
          genericDocument: {
            question: '¿El documento corresponde a una publicación genérica?',
            description:
              'Enviar un mismo documento masivamente a más de un colaborador sin necesidad de que el mismo posea un identificador único',
            option: {
              label: 'No es una publicación genérica',
              legend: ''
            },
            option1: {
              label: 'Si es una publicación genérica',
              legend: ''
            }
          },
          AiDocument: {
            question:
              '¿El colaborador puede enviar este documento para ser analizado por IA?',
            description:
              'El colaborador podrá interactuar con una IA para realizar consultas acerca del documento. Este atributo solo puede estar disponible para un tipo de documento',
            option: {
              label: 'No habilitar',
              legend: ''
            },
            option1: {
              label: 'Sí, habilitar',
              legend: 'Este tipo de documento se podrá enviar a IA'
            }
          },
          salaryReceipt: {
            question: '¿El tipo de documento es recibo de sueldo?',
            option: {
              label: 'Sí'
            },
            option1: {
              label: 'No'
            }
          }
        },
        table: {
          perPage: 'Cantidad por página',
          eform: 'Formulario',
          pdfxml: 'PDF+XML',
          documentType: 'Tipos de documentos',
          modified: 'Modificado <b>{update_at}</b> por <b>{update_fullname}</b>'
        },
        folderEmpty: {
          label: 'Esto es un desierto...',
          label1: 'Aún no hay carpeta creadas',
          link: 'Crear carpeta'
        },
        subFolderEmpty: {
          label: 'esta vacía',
          label1: '¿Quieres crear un tipo de documento?',
          buttonPrimary: 'Crear tipo de documento',
          buttonSecondary: 'En otro momento'
        },
        folderList: {
          title: 'Carpetas creadas',
          buttonPrimary: 'Crear carpeta',
          header: {
            name: 'Nombre de carpeta',
            visible: 'Visible para empleado',
            signature: 'Requiere firma',
            ephemeral: 'Oculto luego de firmar'
          }
        },
        subFolderList: {
          buttonPrimary: 'Crear tipo de documento',
          header: {
            name: 'Nombre tipo documento',
            documents: 'Documentos genéricos',
            publish: 'Colaborador puede publicar',
            signature: 'Posición de firma'
          }
        },
        title: 'Configuración de carpetas',
        tooltipFolder: 'La carpeta posee documentos dentro',
        deleteFolder: 'Eliminar carpeta',
        cancelFolder: 'Cancelar',
        saveFolder: 'Guardar carpeta',
        tooltipSubFolder: 'El tipo de documento posee documentos dentro',
        deleteSubFolder: 'Eliminar tipo de documento',
        cancelSubFolder: 'Cancelar',
        saveSubFolder: 'Guardar documento',
        toolbox: {
          deletePdf: 'Eliminar PDF',
          questionPdf: '¿Quieres eliminar el PDF?',
          notUndo: 'Esta acción no se puede deshacer',
          cancel: 'Cancelar',
          confirmDelete: 'Sí, eliminar',
          cutPdf: 'Seleccionar el área de recorte dentro del documento',
          applyCut: 'Aplicar recorte',
          applying: 'Aplicando corte...',
          cutDone: 'Corte realizado',
          undo: 'Reiniciar',
          undoTitle: 'Reiniciar documento',
          questionUndo:
            'Esta acción revertirá todos los ajustes de rotación y corte aplicados al documento',
          confirmUndo: 'Sí, reiniciar',
          rotation: 'Puedes rotar el documento 90°',
          leftDir: 'Rotar a la izquierda',
          rightDir: 'Rotar a la derecha',
          undoRotation:
            'Esta acción revertirá todos los ajustes de rotación y corte aplicados al documento',
          signShow: 'Mostrar firma en documento',
          singDescription:
            'Puedes configurar la posición de la firma y la página del documento en la que quieres que aparezca',
          firstPage: 'Primera',
          lastPage: 'Última',
          customPage: 'Personalizar',
          singQuestion:
            '¿Quieres volver al posicionamiento de firma por defecto?',
          singEmpQuestion:
            '¿Quieres deshacer el cambio de posicionamiento de firma empleador?',
          loading: 'Subiendo...',
          cut: 'Cortar',
          rotate: 'Rotar',
        },
        signatureTool: {
          singEmployee: 'Firma colaborador',
          singDescription: 'Aquí va a aparecer la firma del colaborador',
          singEmployer: 'Firma Empresa',
          singDescriptionEmployer: 'Aquí va a aparecer la firma de la Empresa'
        },
        emptyState: {
          title: 'Puedes reemplazar este archivo desde',
          link: 'subir pdf'
        },
        pdfInfo: {
          size: 'Tamaño',
          page: 'Página'
        },
        configurationDocumentModal: 'Configuración de documento',
        settingPanel: {
          loadDocument: 'Cargar un documento',
          loadPdf: 'Subir pdf',
          actions: 'Acciones',
          position: 'Posicionamiento',
          exit: 'Salir',
          ok: 'Aceptar'
        }
      }
    },
    actions: {
      delete: 'Eliminar',
      atention: 'Atención',
      error: 'Error',
      not_founded: 'No encontrado',
      empty_list: 'Lista vacia',
      remove: 'Quitar',
      empty_user: 'Lo sentimos, pero no encontramos ningún usuario',
      max_elements: 'Máximo un elemento seleccionado'
    },
    unsubscribe: {
      viewTitle: 'Empleados',
      dropzone: {
        dragText: 'Arraste el archivo aquí o',
        selectText: 'seleccione uno'
      },    
      reasons: {
        termination: "Desvinculación",
        contractEnd: "Fin de contrato", 
        resignation: "Renuncia",
        retirement: "Jubilación",
        candidateDrop: "Baja de candidato",
        others: "Otros"
      },
      confirm_unsubscribe_question:
        '¿Está seguro/a que desea desvincular al empleado?',
      confirm_unsubscribe_why:
        'Seleccione un motivo para dar de baja al empleado',
      confirm_unsubscribe_why_title: 'Motivo',
      confirm_unsubscribe_observation: 'Observaciones',
      confirm_unsubscribe_yes: 'Si',
      confirm_unsubscribe_no: 'No',
      confirm_unsubscribe_success:
        'El empleado ha sido desactivado exitosamente',
      date: 'Fecha de Baja Legal',
      date_invalid: 'Necesita ingresar una fecha de baja',
      title: 'Desvinculación masiva de Empleados',
      description1:
        'En ésta sección usted podrá cambiar el estado de los usuarios a inactivo para que los mismos no puedan seguir recibiendo noticias, solicitando licencias ni enviar documentación.',
      description2:
        'Los usuarios podrán seguir accediendo a la plataforma para consultar los documentos que tienen en su bandeja.',
      description3:
        'Desde el detalle del empleado usted podrá reactivarlo en caso de ser necesario.',
      step_1_title: '1. Crear archivo de usuarios',
      step_1_content: 'Cree un archivo CSV que contenga todos los usuarios que desea desvincular. ',
      step_1_download_example: 'Puede descargar este ejemplo',
      step_1_2_content: 'para completar. Es importante que se respete la cabecera del archivo como primera línea.',
      step_2_title: '2. Seleccione un motivo',
      step_3_title: '3. Adjuntar archivo CSV',
      step_3_extension_dropzone: '*El formato del archivo deberá ser CSV',
      btn_save: 'Procesar archivo',
      alert_format: 'Formato de archivo no compatible',
      count_filename_1: 'Se actualizará el estado de',
      count_filename_2: 'usuarios',
      unsubscribe_valid_pass:
        '¿Está seguro/a que desea desvincular los empleados?',
      action_cancel: 'Cancelar',
      action_unsubscribe: 'Desvincular',
      text_fail_password: 'Contraseña incorrecta',
      text_modal_1: 'Su solicitud se encuentra en proceso',
      text_modal_2:
        'Usted puede volver al buscador de empleados para seguir administrando los empleados ó revisar la acción realizada en el estado de proceso.',
      back_to_search: 'Volver al buscador',
      action_go_process: 'Ir al estado de proceso',
      error_50024: 'El archivo no posee ningún tipo de información',
      error_50027:
        'El archivo esta incompleto, específicamente algun campo de identificador único',
      error_50022: 'El archivo posee formatos de fechas inválidas',
      error_50021:
        'El archivo no se puede procesar, específicamente algún campo de observación es demasiado largo',
      error_50020: 'El archivo no se puede procesar, existen campos vacios',
      error_50023: 'El archivo posee las cabecera inválidas',
      error_50028: 'El usuario de la sesión actual no se puede desactivar',
      error_50029:
        'El formato de la cabecera o los datos no son válidos. Por favor descargue el ejemplo y siga el formato.',
      error_05010:
        'La fecha de baja legal no puede ser menor a la fecha de contratación',
      error_05001:
        'No se desvinculó al empleado, el campo de usuario identificador es requerido',
      error_05002:
        'No se desvinculó al empleado, algún campo ingresado no tiene el formato crrecto',
      error_05003:
        'No se desvinculó al empleado, no se puede desvincular a si mismo',
      error_05004:
        'No se desvinculó al empleado, no tiene permisos para desvicular empleados',
      error_00005:
        'No se desvinculó al empleado, faltan llenar campos necesarios para desvincular',
      error_00072:
        'No se desvinculó al empleado, no se ha encontrado el usuario especificado en el sistema',
      error_50015:
        'No se desvinculó al empleado, el usuario identificado pertenece a otra empresa',
      error_default: 'Hubo un problema al dar de baja al usuario'
    },
    generalSettings: {
      title: 'Centro de seguridad',
      security_title: 'Seguridad',
      mfa_subtitle: 'Autenticación multifactor (MFA)',
      mfa_table_profile_header: 'Perfiles de Gestión',
      mfa_table_required_header: 'Requiere MFA',
      mfa_active_modal_title: 'Activar MFA',
      mfa_active_modal_description:
        'Es necesario que los usuarios pertenecientes a este perfil cuenten con un mail registrado, en caso de no tener uno, perderán el acceso a la cuenta hasta que registren una dirección de correo.',
      mfa_active_modal_cancel: 'Cancelar',
      mfa_active_modal_solicitar: 'Si, Solicitar',
      mfa_active_modal_confirm: 'Entendido',
      errorLogs: {
        unknown: 'Error desconocido',
        parameter_required: 'Faltan parámetros para realizar la operación',
        mfa_not_granted: 'No tiene permisos para realizar esta operación',
        parameter_lenght_exceeded: 'Parámetro con valor límite excedido',
        wrong_type_data: 'Parámetro incorrecto',
        parameter_not_expected: 'Parámetro no esperado',
        mfa_preference_profile_restricted:
          'No se puede agregar MFA para este tipo de perfil'
      }
    },
    mfa: {
      email_validation: {
        title: 'Ingresa un Email',
        sub_title_email_empty:
          'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresas en el siguiente paso.',
        sub_title_email_dirty:
          'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresas en el siguiente paso.',
        go_back_btn: 'Volver',
        send_btn: 'Enviar',
        sending_btn: 'Enviando'
      },
      max_exceeded_resend_fails_mails: {
        title: 'Código de verificación',
        sub_title_max_mails_resend_fails:
          'Realizó demasiados pedidos de verificación, por motivos de seguridad se inhabilitó su cuenta por 1 hora',
        sub_title_max_code_attempts:
          'Realizó demasiados intentos fallidos inicie sesión nuevamente',
        go_back_login_btn: 'Ir al login'
      },
      code_authentication: {
        title: 'Código de verificación',
        sub_title_wrong_code:
          'El código de verificación no es válido. Por favor, inténtelo de nuevo',
        sub_title_valid_code:
          'Ingresá el código de verificación de 6 números que te enviamos a tu email',
        sub_title_expired_code: 'Código expirado',
        sub_title_resend_code: 'Reenviar Código',
        sub_title_time_expired_code: 'El código expira en',
        go_back_btn: 'Volver',
        send_btn: 'Enviar',
        sending_btn: 'Enviando'
      },
      backup: {
        button: 'Realizar Backup',
        heading: 'Backup de Documentos',
        title:
          '¿Estas seguro que quieres solicitar un Backup de tus documentos?',
        content:
          'El Backup se generará y enviará por email luego de las 72 Horas para confirmar el proceso',
        heading_success: 'Solicitud realizada con éxito!',
        content_success:
          'Una vez generado el backup recibirá a su email un enlace para su descarga. La confirmación la recibirá 72hs después de la solicitud.'
      }
    },
    passwordExpired: {
      go_back_btn: 'Volver',
      update_pass_btn: 'Actualizar',
      go_to_dashboard: 'Ir al dashboard',
      pass_expired_message:
        'Tu contraseña expiró. Ingresa tu nueva contraseña.',
      message_error: {
        error_00019: 'La contraseña no cumple las políticas de la empresa',
        error_00026: 'No puede repetir las últimas 3 contraseñas',
        error_00033: 'La nueva contraseña no puede ser igual a la contraseña actual',
        error_00034: 'La contraseña de verificación de identidad es incorrecta',
        error_00141: 'La contraseña no cumple las políticas de la empresa',
        error_00024: 'Hubo un problema al actualizar la contraseña, intente nuevamente',
        error_00046: 'Ha realizado los cambios de contraseña máximos permitidos en el día. Su cuenta se restablecerá dentro de 24hs',
        error_00017: 'Solicitud incorrecta',
        error_00020: 'Token inválido',
        error_00032: 'Las contraseñas no coinciden',
        error_00114: 'Ha superado la cantidad de cambios de clave permitidos. Consulte con el Administrador',
        error_00115: 'No se puede actualizar el registro de claves',
        error_00116: 'No puede repetir las últimas',
        error_00117: 'La contraseña no puede contener información personal del usuario',
        error_00118: "Los campos 'Usuario', 'Nombre' y 'Apellido' son necesarios para validar la contraseña",
        error_00119: 'La contraseña debe ser de mayor complejidad',
        error_00145: 'Debe repetir la nueva contraseña del usuario',
        error_00146: 'Las contraseñas no coinciden',
        error_00147: 'La contraseña nueva no puede ser igual a la actual contraseña',
        error_00148: 'La contraseña de comprobación de identidad es incorrecta',
        error_00144: 'Error al auditar el cambio de contraseña'
      },
      password_validation: {
        required: 'Este campo es requerido',
        no_match_pass: 'Las contraseñas ingresadas no coinciden',
        min_character_rule: 'Este campo debe contener al menos 8 caracteres',
        min_number_rule: 'Este campo debe contener al menos 1 número',
        min_character_info: 'Mínimo 8 caracteres, 1 número'
      },
      password_policies: {
        title: 'La contraseña debe contener:',
        history_pass: 'Distinta a las últimas input contraseñas',
        max_character: 'Máximo input caracteres',
        min_character: 'Mínimo input caracteres',
        no_expire: 'No expira',
        expire: 'Expira en input días',
        special_characters_amount: 'Al menos input caracteres especiales',
        special_character: 'Al menos input input caracter especial',
        min_numbers: 'Al menos input número',
        min_numbers_plural: 'Al menos input números',
        min_capital_letter: 'Al menos input mayúscula',
        min_capital_letters_plural: 'Al menos input mayúsculas',
        min_letter: 'Mínimo input letra(s)',
        notPersonalInfo: 'No puede contener información personal del usuario',
        notEasyPassw:
          'La contraseña no debe ser sencilla (ej. 12345678, qwerty, admin1234, etc.)'
      },
      success: {
        success_message: 'Contraseña actualizada correctamente',
        pls_go_back: 'Por favor, intente volver a ingresar al sistema.',
        go_back_btn: 'Volver al login'
      }
    },
    publishedEforms: {
      go_back_btn: 'Volver',
      parent_title: 'Resultado envíos',
      title: 'Publicaciones realizadas',
      columns: {
        sendBy: 'Enviado por',
        sendDate: 'Fecha y Hora',
        docTypes: 'Tipo documento',
        recipients: 'Destinatarios',
        status: 'Estado',
        actions: 'Acciones'
      },
      paginator: {
        rowsByPage: 'Cantidad por página',
        of: 'de'
      },
      modalRevert: {
        title: 'Revertir envío',
        question: '¿Estas seguro que desea revertir el envío?',
        bodyContent:
          'Al revertir el envío, los formularios digitales involucrados se dejáran de ver en los legajos de cada colaborador, hayan sido completados o no.',
        btn_Revert: 'Si, revertilo'
      },
      filter: {
        title: 'Filtros',
        clear_filter_btn: 'Limpiar Seleccion',
        filter_btn: 'Filtrar'
      },
      recipientsModal: {
        title: 'Destinatarios',
        close: 'Cerrar',
        viewRecipients: 'Ver destinatarios',
        viewDetail: 'Ver detalle',
        revertSend: 'Revertir envío',
        cancel: 'Cancelar',
        documentType: 'Tipo de documento'
      }
    },
    folderSettings: {
      title: 'Configuración de carpetas',
      breadcrumbs_names: {
        0: 'Inicio',
        1: 'Configuración de carpetas'
      },
      subtitle: 'Carpetas disponibles',
      tableHeader: {
        name: 'Nombre',
        count: 'Cantidad',
        visible_for_employee: 'Visible para el empleado',
        signature_required: 'Requiere firma',
        hidden_after_signing: 'Oculto luego de firmar'
      },
      folderDetail: {
        visible: 'Visible',
        signature_required: 'Requiere firma',
        hidden_for_employee_after_signing:
          'Una vez firmado ocultar al empleado',
        keep_employee_inbox: 'Mantener en bandeja del empleado',
        selected_folder_to_block: 'Seleccione carpeta a bloquear',
        tooltip_folder_to_block:
          'Seleccione las carpetas que no podrá acceder hasta haber firmado todos los documentos contenidos en ésta. Ésto es opcional'
      },
      subFolder: {
        title: 'Subcarpetas',
        tableHeader: {
          name: 'Nombre'
        },
        detail: {
          content_eforms: 'Contiene formularios digitales',
          allow_generic_docs: 'Permite la publicación de documentos genéricos',
          allow_documents_load_to_employee:
            'Permite carga de documentos por el empleado',
          selected_template_label: 'Seleccione template',
          advance_config: {
            title: 'Configuración avanzada',
            parser_get_method: 'Método de captura',
            alias_alternative_name: 'Nombre alternativo'
          }
        },
        create: {
          content_eforms: 'Contiene formularios digitales',
          allow_generic_docs: 'Permite la publicación de documentos genéricos',
          allow_documents_load_to_employee:
            'Permite carga de documentos por el empleado',
          selected_template_label: 'Seleccione template',
          advance_config: {
            title: 'Configuración avanzada',
            parser_get_method: 'Método de captura',
            alias_alternative_name: 'Nombre alternativo'
          },
          save_btn: 'Guardar',
          input_placeholder_name: 'Nombre de subcarpeta',
          errors: {
            field_required: 'Este campo es requerido'
          },
          modals: {
            create_success: 'Se creo correctamente la subcarpeta',
            create_success_signature_position:
              'Se configuró el posicionamiento de firma por defecto, para aplicar uno personalizado contactate con soporte',
            create_failed: 'Ocurrio un error',
            question_exit_create: '¿Está seguro que desea cancelar la creación?'
          }
        },
        delete: {
          modals: {
            question_delete: '¿Desea eliminar la sub carpeta?',
            delete_success: 'Borrado correctamente',
            delete_failed: 'Ocurrió un error'
          }
        }
      },
      genericModals: {
        confirm_btn: 'Aceptar',
        cancel_btn: 'Cancelar'
      },
      errorLogs: {
        unknown: 'Error desconocido',
        id_folder_is_required: 'Id de carpeta es obligatorio',
        id_folder_not_valid_integer_value: 'Id de carpeta debe ser numérico',
        name_is_required_value: 'El nombre es obligatorio',
        name_is_not_valid_alphanumeric_value: 'El nombre debe ser alfanumérico',
        type_is_required_value: 'El tipo es obligatorio',
        type_not_valid_alphabetic_value: 'El tipo debe ser alfabético',
        visible_is_required_value: 'Visible es obligatorio',
        visible_does_not_have_valid_boolean_value:
          'Visible sólo admite verdadero/falso',
        signed_does_not_have_valid_boolean_value:
          'Firmable sólo admite verdadero/falso',
        ephemeral_does_not_have_valid_boolean_value:
          'Efimero sólo admite verdadero/falso',
        alias_is_not_valid_alphanumeric_value:
          'Nombre alternativo debe ser alfanumérico',
        id_template_is_not_valid_integer_value: 'Template incorrecto',
        without_code_does_not_have_valid_boolean_value:
          'Documentos genéricos solo admiten verdadero/falso',
        parser_is_not_valid_alphabetic_value:
          'Método de captura debe ser alfabético',
        there_is_sub_folder_with_that_name: 'La subcarpeta ya existe',
        there_is_sub_folder_with_that_alias: 'El nombre alternativo ya existe',
        there_is_not_template_with_that_id: 'Template incorrecto',
        there_is_not_folder_with_that_id: 'La carperta es incorrecta',
        id_sub_folder_is_not_valid_number: 'La subcarpeta es incorrecta',
        there_is_not_sub_folder_with_that_id: 'La subcarpeta es incorrecta',
        this_sub_folder_cant_be_remove:
          'La subcarpeta no se puede eliminar porque ya posee documentos asociados',
        type_of_sub_folder_is_not_modify:
          'El valor de (Contiene formularios digitales) no se puede modificar'
      }
    },
    userActive: {
      title_menu_personal_info: 'Información personal',
      title_menu_configuration: 'Editar perfil',
      title_menu_onboarding: 'Onboarding',
      title_menu_licenses: 'Licencias',
      title_menu_documents: 'Documentos',
      title_employee_active: 'Legajo del empleado',
      subtitle_employee_active: 'Información del Empleado',
      subtitle_employee_active_onboarding:
        'Información provista por el empleado',
      subtitle_employee_active_onboarding_emergencia: 'Contacto de emergencia',
      subtitle_employee_configuration_profiles: 'Configuración de perfiles',
      subtitle_employee_configuration_int_profiles: 'Perfiles de integración',
      change_employee_configuration_profiles:
        'Perfiles modificados correctamente',
      change_employee_configuration_profiles_error:
        'Debe seleccionar al menos un perfil',
      profile_employee_title: 'Perfil empleado',
      profile_management_title: 'Perfiles de gestión',
      profile_management_int_title: 'Asignar perfiles',
      profile_limited_access_title: 'Perfil con acceso limitado',
      profile_employee_tooltip:
        'Perfil diseñado para empleados con permisos para ver, descargar y firmar sus recibos de sueldo. Solo se podrá seleccionar uno por usuario.',
      profile_management_tooltip:
        'Perfiles diseñados para el personal de recursos humanos. Permite gestionar datos de usuarios, notificaciones y recibos de sueldo. Solo se podrá seleccionar uno por usuario.',
      profile_limited_access_tooltip:
        'Perfil diseñado para el personal de recursos humanos con acceso limitado. Permite gestionar datos de usuarios, notificaciones y recibos de sueldo. Solo se podrá seleccionar uno por usuario. Al seleccionar este perfil, podrá configurar filtros por sector y/o locación a continuación.',
      title_employee_filter: 'Filtros por sector y locación',
      select_profile: 'Seleccione un perfil administrador',
      add_employee_filter: 'Agregar',
      subtitle_employee_filter: 'Filtros asignados',
      name_employee_active_onboarding_emergencia:
        'Nombre contacto de emergencias',
      number_employee_active_onboarding_emergencia: 'Teléfono',
      usuario: 'Usuario',
      nombre: 'Nombre',
      apellido: 'Apellido',
      dni: 'Documento de identidad',
      cuil: 'CUIL',
      cuils: 'CUIL',
      fecha_nacimiento: 'Fecha de nacimiento',
      fecha_contratacion: 'Fecha de ingreso',
      numero_legajo: 'Legajo',
      mail: 'Mail',
      duplicatedCuil:
        'El identificador está asociado a otro usuario, por favor verificar',
      cuilWarningMessage:
        'Al modificar el Documento de identidad del colaborador detectamos que tiene {input} documentos asociados a su legajo. Al guardar los cambios quedarán asociados los documentos al nuevo Documento de identidad.',
      modalCuilMessage:
        'Detectamos que el colaborador <strong>{nombre}</strong> con el CUIL <strong>{viejoCuil}</strong> tiene <strong>{documentCounter} Documentos</strong> en su legajo. Los documentos se asociaran al nuevo CUIL <strong>{nuevoCuil}</strong>.<br><br>En caso de cualquier inconveniente puedes contactarte con soporte',
      warningQuestion:
        '¿Quieres guardar y asociar los documentos históricos del colaborador?',
      warningTitle: 'Guardar cambios',
      warningSave: 'Guardar',
      warningCancel: 'Cancelar',
      information_general_employee_active:
        '(*) Corresponde a información proporcionada por el área de Recursos Humanos',
      policies_employee_active: 'Ver Nuestro Aviso de Privacidad',
      empty_onboarding: 'Ninguno',
      title_position_ubication: 'Cargo y ubicación',
      position_position_ubication: 'Cargo',
      report_to_position_ubication: 'Reporta a',
      no_filter: 'No tiene filtros configurados',
      footer_filter:
        'Los siguientes filtros aplican al perfil con acceso limitado',
      profile_employee: 'PERFIL EMPLEADO',
      profile_hhrr: 'PERFIL RRHH',
      other_profiles: 'PERFILES',
      remove_profiles: 'Quitar perfil',
      title_license: 'Configuración de licencias',
      module_license: 'Usa módulo de licencias',
      license_use_module: 'Usa módulo de licencias',
      only_rh: 'Solo RRHH',
      level_one: 'Aprobador nivel 1 y RRHH',
      level_two: 'Aprobador nivel 1 - Aprobador nivel 2 y RRHH',
      tiene_perfil_licencias: 'Perfil licencias',
      tiene_perfil_aprobador: 'Es aprobador',
      approve_license_tooltip:
        'En caso de seleccionar esta opción, cualquier empleado podrá seleccionar a este usuario como aprobador de su licencia',
      numero_legajo_aprobador: 'Número de legajo del aprobador',
      niveles_aprobacion: 'Niveles de aprobación',
      id_politica: 'Políticas',
      antiguedad_previa: 'Antigüedad previa',
      antiquity_license_tooltip:
        'En caso de que el empleado hubiese trabajado anteriormente en la empresa, aquí debe ir la antigüedad que ha acumulado en dicho período indicando en número de meses trabajados.',
      module_license_tooltip:
        'Al activar esta opción podrá configurar los valores del módulo de licencias como aprobadores, políticas aplicables, etc.',
      subtitle_folders_description:
        'Seleccione las carpetas que luego visualizará en el buscador de documentos',
      error_location_seccion_added:
        'El sector y la locación ya se encuentran agregados',
      error_startdate: 'La fecha de contratación es requerida',
      error_borndate: 'La fecha de nacimiento es requerida',
      error_username_change:
        'Deberá restablecer la contraseña del empleado al cambiar el nombre de usuario',
      error_cuil_change:
        'Si cambia este dato el usuario perderá los documentos asociados',
      error_sector_not_found: 'Sector no disponible',
      error_organization_model_not_found:
        'Modelo de organización no disponible',
      error_locacion_not_found: 'Locación no disponible',
      error_int_profiles_not_found: 'Perfiles de integracion no disponibles',
      error_position_not_found: 'Cargo no disponible',
      max_elements: 'Máximo un elemento seleccionado',
      profiles_aclaration: 'Seleccione el tipo de permiso del usuario',
      folders_aclaration:
        'Seleccione las carpetas que el usuario de gestión podrá acceder a consultar su contenido',
      filter_aclaration:
        'Seleccione el sector y locación de los empleados que podrá acceder a la visualización de sus documentos',
      empty_location_and_sector_text:
        'Debe ingresar al menos una locación o sector',
      human_resources: 'RH',
      select_folders: 'Seleccionar carpetas',
      select_location: 'Seleccione un sector',
      select_position: 'Seleccione un cargo',
      select_section: 'Seleccione una locación',
      select_tag_sector: 'Al presionar Enter puedes agregar un nuevo sector',
      select_tag_location:
        'Al presionar Enter puedes agregar un nuevo locacion',
      select_tag_position: 'Al presionar Enter puedes agregar un nuevo cargo',
      tiene_licencias_progresivas: 'Licencias progresivas',
      inicio_dias_progresivos: 'Inicio de dias progresivos',
      fecha_inicio_licencias_progresivas: 'Fecha de inicio días progresivos',
      search_combo_reporta_a: 'Realice una búsqueda...',
      estado: 'Estado',
      activo: 'Activo',
      inactivo: 'Inactivo',
      onboarding: 'Onboarding',
      noSector: 'SIN SECTOR',
      noLocation: 'SIN LOCACION',
      requiredDate: 'Es necesario que ingrese "Fecha de ingreso"',
      textFindLegajo: 'Realice la búsqueda del numero de legajo',
      noFilterSLxSector:
        'No ha seleccionado un filtro por sector y locación. El usuario podrá gestionar empleados del sector y locación al que pertenece',
      noFilterSLrrhh:
        'No ha seleccionado un filtro por sector y locación. El usuario podrá gestionar todos los empleados',
      noFilterFolders:
        'Al aplicar uno o más filtros por carpeta, el usuario únicamente podrá visualizar la documentación en las carpetas seleccionadas. Al no aplicar ningún filtro, el usuario podrá visualizar todos los documentos de los empleados que gestiona, sin restricción.',
      foldersFilters: 'Filtros por carpeta',
      managerProfile:
        'No ha seleccionado un filtro por sector y locación. El usuario únicamente podrá gestionar los empleados que le reportan directamente.',
      alertHasCertSign:
        'Éste perfil puede crear certificados electrónicos. No tienes permiso para realizar modificaciones, contáctate con soporte',
      certSignModal: {
        title: 'Guardar Perfil',
        text_1:
          'No tienes permiso para asignar el perfil de certificados electrónicos',
        text_2:
          'Para asignar el perfil con certificado, es necesario que te contactes con soporte',
        btnOk: 'Entendido'
      }
    },
    listEmployees: {
      ob_down_employees: 'Baja masiva',
      tooltip_cargo:
        'Puesto que desarrolla el empleado en la compañía. Actualizable de forma masiva por CSV en "Carga masiva" o de forma individual en el detalle del empleado',
      tooltip_report:
        'Jefe directo.  Actualizable de forma masiva por CSV en "Carga masiva" o de forma individual en el "Legajo del empleado"'
    },
    login: {
      title_switch: 'Seleccionar Empresa',
      name_btn_switch: 'Ingresar',
      forgot_password: 'Se ha enviado un mail con las instrucciones',
      err404ForgotPass:
        'No encontramos el usuario / email por favor verifica los datos ingresados '
    },
    sso: {
      msgRedirectAuth: 'Autenticando...',
      msgRedirectLogin: 'Ingresando a TuRecibo',
      msgRedirectErrorLogin:
        'Ocurrio un error autentificando el usuario Intentelo nuevamente',
      msgRedirectLoginRRHH: 'Debes ser administrador para acceder'
    },
    homeComponent: {
      birthdays: {
        title: 'Cumpleaños',
        no_events: 'Sin eventos',
        before_yesterday: 'Ante ayer',
        yesterday: 'Ayer',
        today: 'Hoy',
        tomorrow: 'Mañana',
        after_tomorrow: 'Pasado mañana'
      },
      recentHired: {
        title: 'Ingresos del mes',
        no_events: 'Sin eventos',
        show_more: 'Mostrar más',
        show_minus: 'Mostrar menos',
        teammate: 'Compañeros de equipo'
      },
      absentUsers: {
        title: 'Ausencias'
      },
      greeting: 'Hola',
      quick: 'Accesos Rápidos'
    },
    searchComponent: {
      not_founded: 'No encontrado',
      max_elements: 'Máximo un elemento seleccionado',
      fileNumber: 'Número de legajo',
      sectionName: 'Buscador de documentos',
      beforeSection: 'Ir a la versión anterior',
      folder: 'Carpeta',
      document: 'Documento',
      signed: {
        from: 'Firmado desde',
        to: 'Firmado hasta',
      },
      created: {
        from: 'Creación desde',
        to: 'Creación hasta',
      },
      period: {
        from: 'Periodo desde',
        to: 'Periodo hasta',
      },
      eforms: 'Formularios Digitales',
      searchAdvance: 'Busqueda avanzada',
      cleanFilters: 'Limpiar filtros',
      search: 'Buscar',
      employee: 'Usuario',
      searchBy: 'Se puede buscar por Nombres, Apellidos, Cédula de identidad',
      searchBy2: 'Se puede buscar por Nombres, Apellidos, Registration Number',
      searchBy3: 'Se puede buscar por Nombres, Apellidos, Documento de identidad',
      searchBy4: 'Busqueda por',
      documentType: 'Tipo de documento',
      status: 'Estado',
      goTo: 'Ir a',
      page: 'página',
      total: 'Total',
      download: 'Descargar',
      downloadSelected: 'Descargar selección',
      searchDownloadText: 'Descargando...',
      order: {
        ascending: 'Ascendente',
        descending: 'Descendente'
      },
      items: {
        creationDate: 'Fecha de creación',
        name: 'Apellido y Nombre',
        status: 'Estado',
        location: 'Locación',
        period: 'Período',
        sector: 'Sector',
        docType: 'Tipo de documento',
      },
      added: 'Agregados',
      add100: 'Puedes agregar hasta 100',
      separator: 'separados por comas',
      selectAll: 'Seleccionar todo',
      remove: 'Borrar {selectedCuils} seleccionados',
      visor: 'Aquí se visualizaran',
      added1: 'Todas las {cuils} agregadas',
      added2: 'Todos los {cuils} agregados',
      apply: 'Aplicar',
      documentActives: 'Sólo documentos de empleados activos',
      user: 'Empleado',
      searchLimit: 'La búsqueda permite un máximo de 100 {cuil} separado por comas',
      sectorAndLocation: 'Sector y Locación',
      sectors: 'Sectores',
      locations: 'Locaciones',
      filters: {
        hide: 'Ocultar filtros',
        show: 'Mostrar filtros'
      },
      empty: {
        message: 'Los resultados de tu búsqueda se mostrarán aquí',
        legend: 'Para realizar una búsqueda podes ingresa el Nombre, Apellido, Código de identificación en los campo de búsqueda o seleccionar una combinación de filtros.'
      },
      emptyResults: {
        message: 'No se encontraron los resultados para la búsqueda',
        legend: 'Para realizar una búsqueda puedes ingresa el Nombre, Apellido o Código de identificación en los campo de búsqueda o bien seleccionar una combinación de filtros.'
      },
      noUser: 'Empleado inexistente',
      noDoc: 'Documento no disponible'
    },
    label: {
      dni: 'CUIL'
    },
    downloadBackup: {
      cancel: 'Cancelar',
      understood: 'Entendido',
      downloadModal: {
        title: 'Descarga de Backup',
        messageInitialDownload:
          'La descarga de documentos se inició de manera automática.',
        expiredDownload: 'La descarga de tus documentos expiro',
        problemWithDownloadLink: 'Si tienes problemas con la descarga',
        clickHere: 'haz click aquí',
        retryDownload:
          'Si quieres reintentar descargarlos dirigite al buscador de documentos',
        mfaError: 'No tienes habilitado el doble factor de seguridad (MFA)',
        messageMFA:
          'No tienes habilitado el doble factor de seguridad(MFA) para realizar la acción'
      }
    },
    first_login_terms_conditions: 'Acepto los Términos y Condiciones',
    change_image_swal_confirm: 'Sí',
    change_image_swal_deleted: 'Imagen eliminada',
    change_image_swal_rejct: 'No',
    change_image_swal_text: 'No es posible revertir esta acción!',
    change_image_swal_title: '¿Está seguro/a?',
    ei_title: 'Información de Empleado',
    ei_personal_info_title: 'Información personal',
    ei_personal_info_edit: 'Editar',
    ei_personal_send_menssage: 'Enviar mensaje',
    ei_personal_change_password: 'Cambiar contraseña',
    ei_personal_download_file: 'Descargar legajo',
    ei_personal_employee_configuration: 'Configuración empleado',
    ei_personal_employee_suspend: 'Suspender empleado',
    ei_personal_employee_unlink: 'Desvincular empleado',
    ei_personal_employee_change_template: 'Cambiar Plantilla On-boarding',
    ei_personal_info_save_changes: 'Guardar cambios',
    ei_personal_options_button: 'Más opciones',
    ei_personal_data_title: 'Documentos Personales',
    ei_familiares_title: 'Documentos de Familiares',
    ei_personal_formDigital_title: 'Formularios Digitales',
    ei_OnboardingComplete: 'Completo',
    ei_OnboardingIncomplete: 'Incompleto',
    ei_ActiveButton: 'Activar',
    ei_ActiveEmployee: 'Empleado activo',
    ei_InactiveEmployee: 'Empleado Inactivo',
    ei_RefuseImg: 'Rechazar Imagen',
    ei_titleList_text_1: 'Información personal',
    ei_titleList_text_2: 'Datos de Contacto',
    ei_titleList_text_3: 'Dirección',
    ei_titleList_text_4: 'Grupo Familiar',
    ei_titleList_text_5: 'Información bancaria',
    ei_titleList_text_6: 'Datos personales',
    ei_titleList_text_1_1: 'Nombre *',
    ei_titleList_text_1_2: 'Apellido *',
    ei_titleList_text_1_3: 'Documento de identidad *',
    ei_titleList_text_1_4: 'CUIL',
    ei_titleList_text_1_5: 'Sexo',
    ei_titleList_text_1_6: 'Fecha de Nacimiento',
    ei_titleList_text_1_7: 'Legajo',
    ei_titleList_text_1_8: 'Fecha de Inicio *',
    ei_titleList_text_2_1: 'Celular',
    ei_titleList_text_2_2: 'Email',
    ei_titleList_text_3_1: 'Calle',
    ei_titleList_text_3_2: 'Número',
    ei_titleList_text_3_3: 'País',
    ei_titleList_text_3_4: 'Provincia',
    ei_titleList_text_3_5: 'Ciudad',
    ei_titleList_text_3_6: 'Localidad',
    ei_titleList_text_4_1: 'Cónyuge',
    ei_titleList_text_4_2: 'Cantidad de hijos',
    ei_titleList_text_5_1: 'Banco',
    ei_titleList_text_5_2: 'CBU',
    ei_titleList_text_5_3: 'Número de cuenta',
    ei_complete: 'Completo',
    ei_incomplete: 'No Completo',
    ei_apply: 'No Aplica',
    ei_image_not_available: 'Imagen no disponible',
    ei_photo_not_found: 'Imagen no encontrada',
    ei_description:
      '(*) Corresponde a información proporcionada por el área de Recursos Humanos',
    error_50001: 'El nombre del template es obligatorio',
    error_50002: 'Ocurrió un error al modificar el usuario',
    error_50004: 'No se encontraron documentos',
    error_50005: 'El nombre del template es invalido',
    error_50006: 'Parámetros incorrectos',
    error_00217:
      'Error al obtener el archivo previamente agregado durante el onboarding',
    error_50010_1: 'No fue posible procesar el archivo',
    error_50010_2:
      'El archivo cargado excede la cantidad máxima de páginas permitidas',
    error_05006:
      'La fecha de contratación no puede ser menor a la fecha de nacimiento',
    error_05007:
      'Debe existir una diferencia mayor a 17 años entre la fecha de contratacion y la fecha de nacimiento',
    error_05008:
      'Ha ocurrido un error reactivando al usuario, por favor contacte a soporte',
    error_00002: 'Ocurrió un error en la conexión',
    error_00004: 'No se han podido guardar los cambios',
    error_401: 'usuario y/o contraseña incorrecta',
    error_00018: 'usuario bloqueado',
    error_04744:
      'Usuario bloqueado por falta de pago y/o falta de orden de compra, por favor comunicarse con el área de finanzas de VISMA a latam.cobranzas@visma.com',
    error_50013: 'La URL ingresada no es un video.',
    error_05009: 'La fecha de ingreso es inválida.',
    error_05005: 'El empleado no se encuentra en un status de inactivo.',
    error_05143:
      'La fecha de ingreso debe ser mayor a la fecha de baja legal (ver info en el ícono del motivo de baja)',
    error_05144:
      'La fecha de baja no tiene un formato de fecha válido (dd/mm/aaaa)',
    error_05103:
      'La fecha de ingreso no tiene un formato de fecha válido (dd/mm/aaaa)',
    error_50044: 'El mensaje de bienvenida no admite caracteres especiales',
    error_not_onboarding:
      'Usuario en proceso de Onboarding, para continuar debe finalizar el mismo desde',
    error_rrhh: 'Debe ser de RRHH para acceder',
    error_20001: 'El modelo de organización debe ser numérico',
    error_20002: 'El modelo de organización enviado no es un valor válido',
    error_20003: 'No fue posible actualizar el modelo de organización',
    error_20004: 'La integración con Visma People no está disponible',
    form_select: 'Seleccione...',
    title_popover_first_login: 'La clave debe contener:',
    msj_success_title_list: 'Realizado',
    msj_success_list: 'Se ha activado el template correctamente',
    msj_success_modify_user: 'El usuario ha sido modificado exitosamente',
    msj_warning_edit: 'Advertencia',
    msj_warning_edit_date:
      'Es necesario que ingrese "Fecha de ingreso" primero.',
    msj_success_edit: 'template modificado correctamente',
    msj_warning_title_list: 'Atención',
    msj_warning_list: 'El template ha sido desactivado',
    msj_incomplete:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de las secciones "Información personal", "Documentos Personales" y "Documentos".',
    msj_typeImg: 'El tipo de imagen debe ser JPG o PNG',
    msj_sizeImg: 'La imagen debe ser menor de 5 MB',
    head_text_table_list_1: 'Nombre',
    head_text_table_list_2: 'Ultima modificación',
    head_text_table_list_3: 'Estado',
    head_text_table_search_1: 'Nombre y Apellido',
    head_text_table_search_2: 'Email',
    head_text_table_search_3: 'Documento de identidad',
    head_text_table_search_4: 'Legajo',
    head_text_table_search_5: 'Estado',
    head_text_table_search_6: 'Fecha de contratación',
    text_table_status_1: 'Activar',
    text_table_status_2: 'Desactivar',
    head_text_document_1: 'Aplica',
    head_text_document_2: 'Imagen',
    head_text_document_3: 'Obligatorio',
    employees_title: 'Gestión de empleados',
    employees_list_result: 'Lista de empleados',
    employees_list_search_title_error: '¡Esto es un desierto!',
    employees_list_search_desc_error:
      'Lo sentimos, pero no encontramos ningún resultado con los criterios de búsqueda seleccionados. Por favor intente con una combinación distinta.',
    employees_list_search_title:
      'Los resultados de su búsqueda se mostrarán aquí',
    employees_list_search_desc:
      'Para realizar una búsqueda puede ingresar el Nombre, Apellido, Documento de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.',
    employees_list_modal_folder_title: 'Permisos a carpetas',
    employees_list_modal_folder_subtitle: 'Carpetas asignadas',
    employees_list_modal_folder_empty: 'No hay carpetas asignadas',
    employees_list_modal_swal_correct: 'Carpetas asignadas exitosamente',
    employees_list_modal_swal_incorrect:
      'No se cargaron correctamente las carpetas, intente nuevamente',
    employees_list_modal_reset_pass_correct: 'Mail Enviado',
    employees_list_modal_reset_pass_incorrect: 'Error al enviar mail',
    employees_list_modal_reset_pass_incorrect_change:
      'Error al cambiar el mail',
    search_folder_placeholder: 'No hay más carpetas',
    employees_list_modal_reset_subtitle:
      'Se enviará un link al usuario para reestablecer la contraseña',
    employee_export_results: 'Exportar Resultados',
    employee_exporting_results: 'Exportando...',
    employee_activate_selection: 'Activar Selección',
    employee_result: 'Resultados',
    employee_confirm: 'Aceptar',
    employee_edit_error: 'Algo falló!',
    employee_edit_success: 'Usuario modificado exitosamente',
    employee_alert_selection: 'Recordatorio',
    ob_activated_swal_title: 'Buen trabajo!',
    ob_activated_swal_text: 'Se han activado los onboarding!',
    ob_body: 'Cuerpo',
    ob_completed: 'Onboarding',
    ob_create_template: 'Nuevo template',
    ob_documents: 'Documentos',
    ob_load_employees: 'Carga de empleado',
    ob_masive_load_employees: 'Agregar empleados',
    ob_name: 'Nombre de Template',
    ob_not_completed: 'Onboarding',
    ob_not_started: 'Onboarding',
    ob_project: 'OnBoarding',
    ob_info_employee: 'Información para el empleado',
    ob_search_title: 'Empleados',
    ob_select: 'Seleccione',
    ob_select_template: 'Seleccione un template',
    ob_title_model_list: 'Modelo de organización',
    ob_select_model_organization: 'Seleccione el modelo de organización',
    ob_submit_swal_confirm: 'Activar',
    ob_submit_swal_reject: 'Cancelar',
    ob_submit_swal_got_it: 'Entendido',
    ob_submit_swal_text:
      'Una vez realizada esta operación no se podrán deshacer los cambios',
    ob_submit_swal_title: '¿Desea dar de alta al empleado?',
    ob_submit_massive_swal_title:
      '¿Desea dar de alta a los empleados seleccionados?',
    ob_submit_swal_title_eactivate: '¿Desea dar de alta al empleado?',
    ob_sujet: 'Asunto',
    ob_started: 'Onboarding',
    ob_template_digital: 'Template Formulario Digital',
    ob_title: 'Configuración de OnBoarding',
    ob_title_list: 'Templates de Onboarding',
    ob_welcome_message: 'Mensaje de Bienvenida',
    ob_destination_folder:
      'Elige la ubicación donde se almacenarán los documentos del empleado.',
    ob_destination_folder_visible: 'Visible para el empleado',
    ob_destination_folder_notvisible: 'No visible para el empleado',
    ob_move_select_file: 'Arraste o Seleccione un Archivo',
    ob_destination_folder_warning: 'Debe seleccionar una carpeta de destino',
    ob_change_template_tooltip: 'Cambiar Plantilla On-boarding',
    ob_reactivate_user: 'Reactivar empleado',
    ob_reactivate_user_with_license:
      'Deberá activar el módulo de licencias manualmente en la solapa "Configuración" si así lo desea.',
    ob_reactivate_user_success: 'El empleado ha sido reactivado exitosamente',
    ob_reactivate_user_date_note:
      'Info: La fecha a ingresar debe ser mayor a la fecha de baja legal',
    ob_reactive_user_not_date: 'Necesita ingresar fecha de ingreso',
    ob_send_notification: 'Enviar recordatorio de documentos faltantes',
    ob_send_notification_body:
      'Se le enviará un mail a los empleados seleccionados en onboarding que le falten algún documento obligatorio por completar',
    ob_send_notification_response: 'Detalle de envio de recordatorio',
    ob_massive_general_error_response:
      'Algunos empleados no se pudieron activar correctamente',
    ob_update_user_email: 'Actualizar email',
    ob_update_user_email_subtitle: 'Ingrese el nuevo email del colaborador',
    ob_reactive_user_email_exists:
      'El email que ingresó ya se encuentra en uso',
    search_text_select_locacion: 'TODOS',
    search_text_select_sector: 'TODOS',
    search_text_select_centroDeCostos: 'TODOS',
    search_text_select_cargo: 'TODOS',
    search_text_1: 'Búsqueda por:',
    search_text_1_1: 'Documento de identidad, Nombre, Apellido o Email',
    search_text_1_2: 'Legajo',
    search_text_1_3: 'Búsqueda Avanzada',
    search_text_2: 'Estado Empleado',
    search_text_2_1: 'Onboarding',
    search_text_2_2: 'Activo',
    search_text_2_3: 'Inactivo',
    search_text_3: 'Tipo de Perfil',
    search_text_3_1: 'RRHH',
    search_text_3_2: 'Empleado',
    search_text_4: 'Sector',
    search_text_5: 'Locación',
    search_text_6: 'Módulo de Licencias',
    search_text_6_1: 'Aprobador',
    search_text_7: 'Ingreso',
    search_text_7_1: 'No ingresaron',
    search_text_8: 'Sector y Locación',
    search_text_9: 'Seleccionado',
    search_text_10: 'Fecha de contratación',
    search_text_11: 'Fecha de desvinculación',
    search_text_12: 'Centro de costos',
    search_text_date_placeholder: 'Selecione un rango de fecha',
    search_folder_tooltip: 'Configurar carpetas',
    search_reset_pass_tooltip: 'Restablecer clave',
    checkbox_reset_pass_tooltip: 'Generar una clave automáticamente',
    save: 'Guardar Template',
    action_save_template_text: '¡Creado exitosamente!',
    edit: 'Editar',
    return: 'Volver',
    cancel: 'Cancelar',
    search: 'Criterios de búsqueda',
    searchfor: 'Buscar',
    home: 'Inicio',
    menu_1: 'Empleados',
    menu_2: 'Documentos',
    menu_3: 'Vacaciones y Licencias',
    menu_4: 'Empresa',
    menu_5: 'Reportes',
    menu_6: 'Configuración OnBoarding',
    menu_7: 'Legajo digital',
    menu_8: 'Vacaciones y licencias',
    menu_1_1: 'Administrador de empleados',
    menu_1_2: 'Carga Individual de Empleado',
    menu_1_3: 'Carga Masiva de Empleados',
    menu_1_4: 'Recordatorio de firma',
    menu_1_5: 'Monitor de Actividad',
    menu_1_6: 'Carga Individual de Empleado',
    menu_1_7: 'Baja masiva de empleados',
    menu_2_1: 'Publicación de Documentos',
    menu_2_1_1: 'Publicación Masiva',
    menu_2_1_2: 'Publicación Individual',
    menu_2_1_3: 'Publicación de documentos genéricos',
    menu_2_1_4: 'Gestión de Publicaciones',
    menu_2_1_5: 'Buscador de Documentos',
    menu_2_1_6: 'Estado de procesos',
    menu_2_2: 'Formularios Digitales',
    menu_2_2_1: 'Realizar Publicación',
    menu_2_2_2: 'Publicaciones Realizadas',
    menu_2_2_3: 'Administración de Formularios Digitales',
    menu_2_2_4: 'Plantillas de Formularios Digitales',
    menu_2_3: 'Buscador de documentos',
    menu_3_1: 'Gestión de Vacaciones y Licencias',
    menu_3_2: 'Solicitudes',
    menu_4_2: 'Cartelera de noticias',
    menu_4_3: 'Auditoría',
    menu_4_4: 'Configuración',
    menu_4_5: 'Configuración de carpetas',
    menu_4_6: 'Centro de seguridad',
    menu_4_7: 'Certificados de firma electrónica',
    login_text_about_us: 'Sobre nosotros',
    login_text_button: 'Ingresar',
    login_text_contact: 'Contáctenos',
    login_text_forgot_password: '¿Olvidó su contraseña?',
    login_text_language: 'Idioma: ',
    login_text_password: 'Contraseña',
    login_text_user: 'Usuario',
    login_faq_title: 'Preguntas Frecuentes',
    login_faq_one: '¿Has olvidado tu contraseña?',
    login_faq_one_answer:
      "Ingresando a '¿Olvidó su contraseña?'  deberá indicar su usuario y un mail en el cual recibirá las indicaciones para generar una nueva clave de ingreso. En caso de no recibir el correo, deberá ponerse en contacto con el departamento de Recursos Humanos de su empresa, quienes podrán asistirlo para restablecerla.",
    login_faq_two: '¿Se ha bloqueado su usuario?',
    login_faq_two_answer:
      'Luego de varios intentos fallidos para ingresar a la plataforma, por motivos de seguridad, el sistema bloqueará su usuario. Para desbloquearlo deberá ingresar el código solicitado y le enviaremos un correo con instrucciones para ofrecerle nuevos intentos para recuperar su contraseña sin tener que modificarla. En caso de no poseer un correo electrónico registrado, deberá ponerse en contacto con el departamento de Recursos Humanos de su empresa. quienes podrán asistirte para restablecerla.',
    login_faq_three: 'Información general de seguridad',
    login_faq_three_answer:
      'La plataforma ha sido testeada con los más rigurosos métodos de seguridad informática, y la comunicación se realiza de manera encriptada utilizando el protocolo https, el mismo que utilizan bancos, tarjetas de crédito, sitios de pagos por Internet, etc.',
    login_faq_close_button_text: 'Cerrar',
    login_need_help: '¿Necesita Ayuda?',
    login_mail:
      'El email informado es utilizado para facilitar la recuperación de la clave y la notificación de un recibo nuevo. Es muy importante que ingrese una cuenta.',
    login_first_login_title: 'Primer Ingreso',
    login_first_login_subtitle:
      'Por razones de seguridad debe cambiar su clave de ingreso al sistema',
    login_first_login_password_field_label: 'Nueva clave',
    login_first_login_repeat_password_field_label: 'Confirme nueva clave',
    confirm_password: 'Reingrese clave',
    login_first_login_no_email_label: 'No poseo cuenta de email',
    login_first_login_email_field_help_text:
      'Recuerde ingresar un email válido, ya que será verificado durante el proceso',
    login_first_login_required_field: 'Este campo es requerido',
    login_commercial_info: 'Información Comercial',
    login_welcome_title:
      'Gestione la información y documentación de su equipo donde y cuando quiera',
    login_welcome_subtitle:
      'Ahorre tiempo y dinero con la Gestión Digital de los Documentos de Recursos Humanos',
    login_send: 'Enviar',
    login_go_back: 'Volver',
    login_request_password_title: 'Recupero de Contraseña',
    login_jwt_expired: 'Su sesión ha expirado.',
    footer_privacy_policy: 'Políticas de privacidad',
    footer_public_certificate: 'Certificado público de turecibo.com',
    product_name: 'Tu Recibo',
    header_top_bar_change_company: 'Cambiar empresa',
    header_top_bar_edit_password: 'Editar clave',
    header_top_bar_edit_email: 'Editar email',
    header_top_bar_logout: 'Salir',
    header_top_bar_modal_save: 'Guardar',
    header_top_bar_new_mail: 'Email nuevo',
    header_top_bar_password_changed_message:
      'Su clave ha sido cambiada con éxito.',
    header_top_bar_accept_button_text: 'Aceptar',
    header_top_bar_mail_changed_message: 'Su email ha sido cambiado con éxito.',
    header_top_bar_change_company_text: 'Cambiar empresa',
    header_top_bar_change_avatar_text: 'Cambiar Avatar',
    home_button_publish: 'Publicar Documentos',
    home_button_main:
      'Aquí encontrarás los accesos más frecuentes para que puedas agilizar tu tiempo dentro de la plataforma.',
    home_button_add: 'Administrar Empleados',
    home_create_users: 'Agregar empleados',
    home_button_adm_users: 'Administrador de empleados',
    home_button_search_users: 'Gestión de publicaciones',
    home_adm_publish: 'Administrador de procesos',
    home_button_reports: 'Gestión de reportes',
    home_welcome_again: 'Bienvenido',
    home_button_publish_news: 'Publicar noticia',
    switch_user_company_text: 'Empresa',
    switch_user_profile_text: 'Perfil',
    switch_user_status: 'Estado',
    switch_user_profile_employee: 'Empleado',
    switch_user_profile_rrhh: 'Recursos Humanos',
    swal_error: 'Ha ocurrido un error!',
    title_404: 'Lo sentimos, pero la página no fue encontrada',
    sub_title_404: 'Afortunadamente usted puede volver a buscar en el home',
    btn_text_back_to_home: 'Volver al home',
    title_403: 'Lo sentimos, pero usted no tiene acceso a esta página',
    sub_title_403:
      'Si usted no es administrador puede ir al sitio de empleado o volver al home',
    yes_logout_text: 'Sí',
    not_logout_text: 'No',
    headerInfoPersonal: 'Información personal',
    headerDocPers: 'Documentos Personales',
    confirm_delete_img_text: 'Está seguro que desea eliminar la imagen?',
    header_logout: 'Aviso',
    downloadDocument: 'Descargar Documento',
    textNoOnboarding: 'Este empleado no ha pasado por un proceso de Onboarding',
    error_eForms:
      'No es posible conectarse con el módulo de eForms, aguarde o póngase en contacto con el proveedor',
    header_top_bar_modal_change_button: 'Cambiar',
    copyrightText: 'Copyright',
    err_title:
      'No fue posible guardar los cambios. El nombre del template de Onboarding es obligatorio',
    err_infoPersonal:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de la sección "Información personal" (Grupo familiar es opcional)',
    err_docPersonales:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de la sección "Documentos Personales"',
    err_eF:
      'No fue posible guardar los cambios. Es obligatorio seleccionar por lo menos un ítem de la sección "Documentos"',
    err_img:
      'No fue posible guardar los cambios. Usted seleccionó "Imagen institucional", es obligatorio cargar una imagen',
    err_video:
      'No fue posible guardar los cambios. Usted seleccionó "Video institucional", es obligatorio escribir una url',
    billboard_form_header_create_title: 'Nueva Publicación',
    billboard_form_header_edit_title: 'Editar Publicación',
    billboard_form_content_validator_message:
      'Debe ingresar al menos un contenido de texto, imagen o video',
    billboard_form_submit_button_text: 'Publicar',
    billboard_form_cancel_button_text: 'Cancelar',
    billboard_form_post_preview_text: 'Previsualizar',
    billboard_form_post_details_text: 'Detalles de la publicación',
    billboard_form_post_sectors_text: 'Sectores',
    billboard_form_post_locations_text: 'Locaciones',
    billboard_form_post_recipients_text: 'Destinatarios',
    billboard_form_post_input_valid_from_placeholder: 'Válida desde',
    billboard_form_post_input_valid_to_placeholder: 'Válida hasta',
    billboard_form_post_update_success_text: 'Publicación actualizada.',
    billboard_form_post_button_confirm: 'Aceptar',
    billboard_form_post_error: 'Ocurrió un error',
    billboard_form_post_create_success_text: 'Publicación realizada.',
    billboard_form_dates_validator_message:
      'La fecha de expiración de la publicación debe ser mayor a la fecha de inicio',
    billboard_form_textarea: 'Mensaje',
    billboard_form_videos_validator_message:
      'Sólo se admiten videos de vimeo o Youtube',
    billboard_list_delete_success_message: 'Notificación eliminada.',
    billboard_list_header_title: 'Publicaciones recientes',
    billboard_list_grid_title_column: 'Título de la publicación',
    billboard_list_grid_valid_from_column: 'Válido desde',
    billboard_list_grid_valid_to_column: 'Válido hasta',
    billboard_list_grid_author_column: 'Autor',
    billboard_list_grid_state_column: 'Estado publicación',
    billboard_list_grid_active_state_text: 'Activa',
    billboard_list_grid_inactive_state_text: 'Inactiva',
    billboard_summary_posts_title: 'Publicaciones',
    billboard_list_delete_confirm_message_title:
      '¿Está seguro/a que desea borrar la notificación?',
    billboard_list_delete_confirm_message_subtitle:
      'Una vez realizada esta operación no se podrá deshacer',
    billboard_list_delete_confirm_button_text: 'Sí',
    billboard_list_delete_cancel_button_text: 'No',
    billboard_create_button_text: 'Nueva publicación',
    billboard_page_title: 'Cartelera de noticias',
    billboard_title_invalid: 'Se ha ingresado un texto inválido',
    text_eform_not_found: 'No ha creado ningún formulario',
    billboard_modal_preview_title: 'Previsualización',
    billboard_lazy_loading_text: 'Cargando ...',
    onboarding_empty_1: 'Parece que no existen templates creados',
    onboarding_empty_2:
      'Al crear un template de onboarding usted podrá configurar los distintos procesos de admisión que deberán completar sus futuros empleados',
    billboard_loading_text: 'Publicando ...',
    billboard_empty_location_and_sector_text:
      'Debe ingresar al menos una locación y un sector',
    billboard_forbidden_file_type_text: 'Formato de archivo no compatible',
    onboarding_label_by_page: 'Mostrar',
    uploadImageComponent: {
      filterBar: {  
        formName: 'Nombre Formulario',
        filters: 'Filtros',
        form: 'Formulario',
        selfService: 'Autogestión',
        status: 'Estado',
        active: 'Activo',
        inactive: 'Inactivo',
        packages: 'Paquetes de envíos',
        select: 'Seleccione...',
      },
      header: {
        titleHeader: 'Bandeja de tareas',
        subtitleHeader1: 'Inicio'
      },
      topBar: {
        approveButton: 'Aprobar',
        rejectButton: 'Rechazar'
      },
      modals: {
        fileUploadVisualizerTitle: 'Visualización de documento',
        individualErrorModalTitle: 'Problema al procesar el documento',
        individualRejectModalTitle: 'Motivo de rechazo',
        individualRejectWarning: 'Estás a punto de rechazar este documento',
        individualRejectWarning2: 'Esta acción no se puede deshacer',
        individualRejectPlaceholderTextArea:
          'Ingresa el motivo de rechazo del documento',
        individualRejectSuccessfulModalTitle: 'Documento rechazado',
        individualRejectDocumentRejected: 'Documento rechazado',
        individualRejectInfo: 'Rechazaste el ',
        multipleRejectWarning: 'Estás a punto de rechazar {input} documentos',
        multipleRejectPlaceholderTextArea:
          'Ingresa el motivo de rechazo de los documentos',
        multipleApproveModalTitle: 'Aprobar seleccionados',
        multipleApproveConfirm:
          '¿Estás seguro de querer <strong>Aprobar</strong> los <strong>{input} elementos seleccionados</strong> de tu bandeja de tareas?',
        multipleApproveWarning: 'Esta acción no se puede deshacer',
        multipleRejectDocumentRejected: 'Documentos rechazados',
        buttonApprove: 'Aprobarlos',
        buttonApproveLoading: 'Aprobando...',
        buttonReject: 'Rechazar',
        buttonRejectLoading: 'Rechazando...',
        buttonCancel: 'Cancelar',
        individualError:
          'Ocurrió un error al procesar el documento, por favor vuelva a intentarlo',
        pleaseWait: 'Si el problema persiste aguarde unos minutos',
        buttonUnderstand: 'Entendido',
        multipleApproveSuccess: 'Documentos aprobados',
        xDocumentsApproved: '{quantity} Registros aprobados',
        handledErrorsModalTitle: 'Problema al procesar el documento',
        handledErrorsMessage:
          'Ocurrió un error con los siguientes {quantity} documentos de tu selección',
        buttonRetry: 'Reintentar',
        buttonRetryLoading: 'Reintentando...'
      },
      body: {
        noPendingTasks: {
          title: 'No hay documentos en tu bandeja de tareas',
          content: 'Relájate y disfruta el momento'
        },
        leftContainer: {
          filter: {
            searchFilter: 'Filtros de búsqueda',
            filterButton: 'Filtros',
            searchLabel: 'Buscar',
            inputPlaceholder:
              'Nombre, apellido, identificador único, fecha, sector y locación',
            inputBaseMessage:
              'Buscar por Nombre, Apellido, Identificador único',
            SelectOption: 'Ordenar por:',
            allFiltersOn: 'Todos',
            date: 'Fecha',
            documentType: 'Tipo de documento',
            name: 'Nombre',
            cuil: 'Cuil',
            sector: 'Sector',
            time: 'Hora',
            orderBy: 'Ordenado por:',
            locacion: 'Locación',
            document: 'Tipo de documento',
            asc: 'Ascendente',
            desc: 'Descendente'
          },
          multipleSelection: {
            oneSelectedItem: '1 seleccionado',
            xSelectedItems: '{quantity} seleccionados',
            selectAll: 'Seleccionar los otros {total} registros'
          },
          singleApprove: {
            questionApprove: '¿Está seguro/a que desea aprobar el documento?',
            singleApproveSuccess: 'El documento ha sido aprobado',
            singleApproveError: 'Hubo un error al aprobar el documento'
          },
          singleDeny: {
            denySingle: 'Rechazo de documento',
            questionDeny: '¿Está seguro/a que desea rechazar el documento?',
            singleDenySuccess: 'El documento ha sido rechazado',
            singleDenyError: 'Hubo un error al rechazar el documento'
          },
          massiveApprove: {
            buttonApproveAll: 'Aprobación Masiva',
            questionMassiveApprove:
              '¿Está seguro/a que desea aprobar masivamente los documentos seleccionados?',
            massiveApproveSuccess: 'Los documentos han sido aprobados',
            massiveApproveError:
              'hubo un error al aprobar masivamente los documentos'
          },
          massiveDeny: {
            buttonDenyAll: 'Rechazo Masivo',
            denyAll: 'Rechazo Masivo de documentos',
            denyAllText:
              'El rechazo del documento envia un mail notificando al empleado.',
            denyAllPlaceholder: 'Describa el motivo de rechazo',
            questionMassiveDeny:
              '¿Está seguro/a que desea rechazar masivamente los documentos seleccionados?',
            massiveDenySuccess: 'Los documentos han sido rechazados',
            massiveDenyError:
              'Hubo un error al rechazar masivamente los documentos'
          },
          generalErrors: {
            errorOnSubmit: 'Hubo un error',
            errorOnLoadCards:
              'Hubo un error en mostrar las cargas pendientes de los usuarios'
          },
          noMoreResults: 'No hay más resultados',
          noMoreSearchingFromUser: 'No hay tareas que coincidan con tu búsqueda'
        },
        rightContainer: {
          noContentEmptyState: {
            title: 'Aquí se visualizarán los tipos de documentos',
            content:
              'Puedes elegir multiples documentos y aprobarlos o rechazarlos masivamente'
          },
          employeeInfo: {
            attaches: 'Adjuntos',
            dontHaveIt: 'No tiene',
            pages: 'Página'
          },
          image: {
            problemWithImage:
              'Hubo un problema al cargar la imagen, por favor consulte con soporte',
            page: 'Página',
            loading: 'Cargando documento'
          },
          multipleSelection: 'Selección múltiple de documentos'
        },
        noContentEmployeeInfo: {
          noSector: 'No posee sector',
          noLocacion: 'No posee locación',
          noCuil: 'No posee Cuil',
          noArchiveName: 'Sin nombre de carga',
          noDate: 'No posee fecha'
        },
        swalButtons: {
          cancel: 'No',
          accept: 'Aceptar',
          approve: 'Si',
          deny: 'Si'
        }
      },
      errorLogs: {
        '04002':
          'El empleado no pertenece a la empresa a la del usuario que subio el documento',
        '04003': 'Formato invalido',
        '04004': 'El PDF no puede exceder el total de páginas permitidas',
        '04005': 'Error al cargar el archivo',
        '04006': 'El campo nombre es requerido',
        '04007': 'El campo template es requerido',
        '04008': 'No eres administrador',
        '04009': 'El campo nombre es requerido',
        '04010': 'El campo Json es requerido',
        '04011': 'No se pudo obtener el usuario',
        '04012': 'No tienes permiso para realizar esta acción',
        '04013': 'El parámetro Id_type_document es requerido',
        '04014': 'El parámetro Template es requerido',
        '04015': 'El parámetro Files es requerido',
        '04016': 'El usuario no posee el action profile requerido',
        '04018': 'La cantidad de archivos subidos es incorrecta',
        '04019': 'El campo de valor es requerido',
        '04020': 'El Id_type_documen no pertenece a la compañia',
        '04021': 'Formato del Json invalido',
        '04022': 'Se debe agregar parametros junto al Json',
        '04023': 'Los parámetros adentro del Json son incorrectos',
        '04024':
          'El empleado no pertenece al sector del usuario que subio el documento',
        '04025':
          'El empleado no pertenece a la locacion del usuario que subio el documento',
        '04026': 'El documento debe estar en estado inicial',
        '04027': 'El status fue cambiado con éxito',
        '04028': 'Error al actualizar la base de datos',
        '04029': 'El status fue cambiado con éxito',
        '04030': 'El parámetro País no es correcto',
        '04031': 'El parámetro compañia no es correcto',
        '04032': 'El ID de la empresa debe ser numérico',
        '04033': 'El ID del país debe ser numérico',
        '04034': 'El ID es requerido',
        '04035': 'El nombre es requerido',
        '04036': 'El formato del archivo es incorrecto',
        '04037': 'El ID es incorrecto',
        '04038': 'El ID no pertenece a la carga del usuario',
        '04039': 'La carga del archivo falló',
        '04040': 'Nombre incorrecto.',
        '04041': 'Error al actualizar el template',
        '04042': 'Ya se completo la carga maxima de archivos',
        '04043': 'No puedes ver documentos de otras compañías',
        '04044': 'El campo hash es requerido',
        '04045': 'Los hash no coinciden',
        '04046': 'No se pudo crear el directio correctamente',
        '04047': 'El documento no existe',
        '04048': 'Error al unir archivos',
        '04049': 'El archivo excede el tamaño máximo',
        '04051': 'No se puede leer el archivo PDF',
        '05000': 'Desconocido',
        '05101': 'Licencias progresivas no tiene un valor válido',
        '05102': 'La fecha de nacimiento no tiene un fecha válida',
        '05103': 'La fecha de contratación no tiene un fecha válida',
        '05104': 'La fecha de contratación no tiene un fecha válida',
        '05105': 'El legajo no es número entero válido',
        '05106':
          'Niveles de aprobación de licencias progresivas no tiene un fecha válida',
        '05107': 'El número de legajo de aprobador no es número entero válido',
        '05108':
          'La antigüedad previa de licencias progresivas no es número entero válido',
        '05109':
          'El ID de políticas de licencias progresivas no es número entero válido',
        '05110': 'El ID de la empresa es requerido',
        '05111': 'El usuario es requerido',
        '05112': 'El nombre es requerido',
        '05113': 'El apellido es requerido',
        '05114': 'El DNI es requerido',
        '05115': 'El CUIL es requerido',
        '05116':
          'El nombre debe contener entre 1 y 50 caracteres alfanuméricos',
        '05117':
          'El apellido debe contener entre 1 y 50 caracteres alfanuméricos',
        '05118': 'El mail no tiene un formato válido',
        '05119':
          'El usuario debe contener entre 1 y 32 caracteres alfanuméricos, incluidos caracteres alfanuméricos, dígitos y guiones bajos',
        '05120':
          'El dni debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas',
        '05121':
          'El cuil debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas',
        '05122':
          'El sector debe ser alfanumérico con barras, espacios y/o comas y no debe exceder los 250 caracteres',
        '05123':
          'La locación debe ser alfanumérico con barras, espacios y/o comas y no debe exceder los 250 caracteres',
        '05124': 'El usuario es duplicado',
        '05125': 'El mail es duplicado',
        '05126': 'El dni es duplicado',
        '05127': 'El cuil es duplicado',
        '05128':
          'La fecha de nacimiento no puede ser una fecha posterior a hoy',
        '05129': 'La fecha de nacimiento denota un empleado menor de edad',
        '05130':
          'La fecha de contratación no debe superar los 40 días a partir de hoy',
        '05131':
          'La fecha de nacimiento debe ser superior a la fecha de contratación',
        '05132':
          'Debe haber una diferencia de 14 años entre la fecha de nacimiento y la fecha de contratación',
        '05133': 'El legajo es duplicado',
        '05134': 'La contraseña o el mail son requeridos',
        '05135': 'La clave debe tener al menos 8 caracteres',
        '05136': 'Saltear el mail de bienvenida no tiene un valor válido',
        '05137':
          'El cambio del valor puede desvincular las publicaciones de documentos del usuario',
        '05138':
          'El cambio del valor puede invalidar la contraseña, debes resetearla',
        '05139':
          'La fecha de contratación es obligatoria y no se puede modificar',
        '05140':
          'No se ha podido actualizar el número de legajo ya que es aprobador de otro empleado.',
        '05141': 'La fecha de contratación del usuario es requerida'
      },
      fileUploadLicenses: {
        title: 'Novedades en el modulo de Vacaciones y licencias',
        description: 'A partir de ahora los colaboradores podran adjuntar archivos en sus solicitudes de licencias.',
        knowMore: 'Saber más',
        benefits: {
          title: 'Algunos beneficios de esta nueva funcionalidad:',
          list: [
            'Los colaboradores podrán cargar documentación respaldatoria en un simple paso al momento de la solicitud',
            'Los aprobadores podrán consultar y descargar la documentación para tomar mejores decisiones',
            'La carga obligatoria u optativa es configurable'
          ]
        },
        howToActivate: {
          title: '¿Como activarlo?',
          description: 'Contactarse con',
          support: 'Soporte técnico'
        }
      },
      maintenance: {
        title: 'Mantenimiento de plataforma',
        understood: 'Entendido'
      },
      digitalFile: {
        title: 'Tenemos un nuevo módulo para vos',
        description: 'Hola {name}. Está disponible el módulo: Legajo Digital.',
        close: 'Cerrar'
      },
      vismaCommunity: {
        enter: 'Ingresar',
        later: 'En otro momento'
      },
      taskWidget: {
        documents: 'Documentos',
        toReview: 'a revisar',
        goToInbox: 'Ir a bandeja de tareas'
      },
      employeeStatus: {
        title: 'Empleados Activos',
        onboardingTitle: 'Empleados Onboarding'
      },
      leftMenu: {
        knowMore: 'Conocer más',
        taskInbox: 'Bandeja de Tareas',
        userManual: 'Manual de usuario'
      },
      onboarding: {
        subject: 'Asunto'
      },
      detailEform: {
        status: 'Estado',
        active: 'Activo',
        inactive: 'Inactivo',
        packages: 'Paquetes de envio:',
        selfService: 'Autogestión',
        selfServiceDescription: 'Al activar la autogestión, el formulario estará a disponible en la plataforma para que los colaboradores lo completen y envíen al área de Recursos Humanos en el momento que lo necesiten.',
        destinationFolder: 'Carpeta destino',
        folderError: '* Escoga una carpeta válida para guardar el documento',
        requiresApproval: 'Requiere aprobación de RRHH',
        isCertificate: 'Es un certificado',
        certificateDescription: 'Al activar el formulario como certificado, estaran disponibles en la plataforma de los colaboradores para ser descargados de forma automatica.',
        save: 'Guardar',
        saving: 'Guardando...',
        successMessage: 'Documento digital modificado'
      }
    },
    text_mask_character: '(máximo 140 caracteres)',
    crossSelling: {
      digitalFile: {
        landing: {
          title: '¿Qué puedes realizar en legajo digital?',
          item_1: 'Tener una experiencia de OnBoarding 100% digital',
          item_2: 'Completar y firmar todos los documentos de ingreso',
          item_3:
            'Presentar toda la documentación requerida en formato digital',
          item_4: 'Conocer a su equipo de trabajo',
          item_5: 'Tener las respuestas a sus preguntas frecuentes',
          buttonDefault: 'Quiero más información',
          buttonSent: 'Solicitud enviada'
        },
        toaster: {
          title: 'Legajo Digital información',
          containerText:
            'Hola {nombre}! Muchas gracias por contactarte con nosotros. Un asesor comercial te contactará en las próximas 24-48hs para brindarte la información que solicitaste.',
          button: 'Entendido'
        }
      },
      licenses: {
        landing: {
          title: '¿Qué puedes realizar en Vacaciones & Licencias?',
          item_1:
            'Los empleados podrán solicitar vía mobile o desktop vacaciones y licencias',
          item_2: 'Podrás aprobar o rechazar solicitudes pendientes',
          item_3:
            'Tendrás un potente reporte de saldos y buscador de solicitudes pasadas',
          item_4: 'Flujo de aprobadores por niveles',
          item_5: 'Adaptable a los convenios y regulaciones de tu país',
          buttonDefault: 'Quiero más información',
          buttonSent: 'Solicitud enviada'
        },
        toaster: {
          title: 'Vacaciones y licencias información',
          containerText:
            'Hola {nombre}! Muchas gracias por contactarte con nosotros. Un asesor comercial te contactará en las próximas 24-48hs para brindarte la información que solicitaste.',
          button: 'Entendido'
        }
      }
    },
    documentSearch: {
      searchTitlePreview: 'Vista previa del documento',
      searchDownloadText: 'Descargando...',
      donwload: {
        searchToExcel: 'Resultados a hoja de calculo',
        eformsData: 'Datos de formularios digitales',
        observations: 'Observaciones sobre documentos',
        undoSelection: 'Anular Selección',
        popup: {
          eformsData: {
            header: 'Descargar datos de formularios digitales',
            body_a:
              'A continuación se mostraran todos los formularios que aparecen dentro del resultado de la busqueda.',
            body_b:
              'Al descargar los datos los obtendra en formato de hoja de cálculo',
            column_name: 'Nombre Template',
            column_action: 'Descargar datos'
          },
          observations: {
            header: 'Descargar observaciones sobre documentos',
            empty:
              'Los documentos mostrados no presentan observaciones registradas.'
          }
        }
      }
    },
    profileModals: {
      switchCompany: {
        current: 'Actual',
        profile: 'Perfil',
        myCompanies: 'Mis empresas',
        change: 'Cambiar',
        ipRestricted: 'Restringido por IP',
        blockedCompany:
          'Empresa bloqueada por motivos administrativos. Por favor comunicarse con el área de Finanzas de VISMA a latam.cobranzas@visma.com'
      },
      editPass: {
        title: 'Cambia tu clave de acceso',
        currentPass: 'Ingrese clave actual',
        newPass: 'Ingrese nueva clave',
        repeatPass: 'Repita nueva clave',
        notSamePass: 'Las contraseñas no coinciden'
      },
      editMail: {
        title: 'Cambia tu email personal',
        currentMail: 'Tu correo electrónico actual asociado es',
        inputsTitle: 'Introduce un correo electronico nuevo y tu clave actual',
        newMail: 'Correo electrónico nuevo',
        password: 'Clave actual'
      },
      save: 'Guardar',
      cancel: 'Cancelar'
    },
    vismaIntegrations: {
      vismaPeople: {
        errors: {
          VISMA_PEOPLE_PUT_APPROVE_ABSENCE_NOT_FOUND:
            'No se pudo encontrar la licencia en Visma People, contacte con su administrador.',
          VISMA_PEOPLE_PUT_APPROVE_ABSENCE_ERROR:
            'No se pudo procesar la solicitud en este momento, inténtelo más tarde.',
          VISMA_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST:
            'Hubo un incoveniente al procesar la solicitud',
          VISMA_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST_StatusNotAllowed:
            'La licencia ya fue procesada'
        }
      },
      vismaCommunityWidget: {
        title: 'Últimas Novedades',
        noContent: 'No hay novedades',
        viewMore: 'Ver más novedades'
      },
      homeDashboard: {
        title: 'Novedades en nuestros productos',
        info: 'Ingresa a <b>Visma Community</b> y descubre toda la información del software, HR y mucho más.',
        confirm_btn: 'Ir a Visma Community'
      },
      activateOnboarding: {
        ob_massive_download_csv:
          'Descargue el listado de errores para identificar a los empleados afectados',
        dowload_btn: 'Descargar',
        cancel_btn: 'Cancelar',
        errorIE:
          'Esta funcionalidad no está soportada en IE, por favor utilice otro navegador',
        errors: {
          generic:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          InvalidDocumentIdentifier:
            'El formato del número de documento de identidad es incorrecto',
          EmployeeFoundWithSameDocumentAndSameFileNumber:
            'Se encontró un Empleado con el mismo tipo y número de Documento',
          FileNumberExists: 'El Legajo está duplicado en VP, revisar los datos',
          EmployeeNotFoundWithFileNumberAndDocumentNumber:
            'El legajo enviado no coincide con los datos en VP, revisar los datos',
          EmployeeNotFound:
            'El DNI,CUIL o Legajo del usuario no coincide con la información existente en Visma People, por favor revise la información y actualice donde corresponda.'
        },
        success: {
          title: 'Empleado activado con observaciones',
          info: 'Se creó el usuario en Visma People pero con errores en alguno de sus campos. Puede terminar de completar la información dentro de Visma People.'
        },
        validations: {
          modal_title: 'Los siguientes campos son obligatorios',
          modal_subtitle:
            'No podrá activar el empleado hasta que el mismo complete la siguiente información',
          VP_FIRSTNAME_IS_REQUIRED: 'Nombre',
          VP_LASTNAME_IS_REQUIRED: 'Apellido',
          VP_NATIONALITY_IS_REQUIRED: 'Nacionalidad',
          VP_GENRE_IS_REQUIRED: 'Género',
          VP_BIRTHDATE_IS_REQUIRED: 'Fecha de nacimiento',
          VP_BIRTHDATE_IS_INVALID: 'Fecha de nacimiento es inválida',
          VP_CIVIL_STATUS_IS_REQUIRED: 'Estado civil',
          VP_DNI_IS_REQUIRED: 'DNI',
          VP_DNI_IS_DUPLICATED:
            'Detectamos que el número de documento del usuario, se encuentra duplicado en Visma People',
          VP_CUIL_IS_REQUIRED: 'CUIL',
          VP_ADDRESS_TYPE_IS_REQUIRED: 'Tipo de domicilio',
          VP_STREET_NAME_IS_REQUIRED: 'Calle',
          VP_STREET_NUMBER_IS_REQUIRED: 'Número',
          VP_ADDRESS_FLOOR_IS_REQUIRED: 'Piso',
          VP_ADDRESS_DEPARTMENT_NUMBER_IS_REQUIRED: 'Departamento',
          VP_ZIPCODE_IS_REQUIRED: 'Código postal',
          VP_LOCALITY_IS_REQUIRED: 'Localidad/Ciudad',
          VP_PROVINCE_IS_REQUIRED: 'Provincia',
          VP_COUNTRY_IS_REQUIRED: 'País',
          VP_ORGANIZATION_MODEL_IS_REQUIRED: 'Modelo de organización',
          VP_HIREDATE_IS_REQUIRED: 'Fecha de ingreso/contratación'
        },
        massive_validations: {
          VP_FIRSTNAME_IS_REQUIRED: 'Nombre es requerido',
          VP_LASTNAME_IS_REQUIRED: 'Apellido es requerido',
          VP_NATIONALITY_IS_REQUIRED: 'Nacionalidad es requerido',
          VP_GENRE_IS_REQUIRED: 'Género es requerido',
          VP_BIRTHDATE_IS_REQUIRED: 'Fecha de nacimiento es requerido',
          VP_BIRTHDATE_IS_INVALID: 'Fecha de nacimiento es inválida',
          VP_CIVIL_STATUS_IS_REQUIRED: 'Estado civil es requerido',
          VP_DNI_IS_REQUIRED: 'DNI es requerido',
          VP_DNI_IS_DUPLICATED:
            'Detectamos que el número de documento del usuario, se encuentra duplicado en Visma People',
          VP_CUIL_IS_REQUIRED: 'CUIL es requerido',
          VP_ADDRESS_TYPE_IS_REQUIRED: 'Tipo de domicilio es requerido',
          VP_STREET_NAME_IS_REQUIRED: 'Calle es requerido',
          VP_STREET_NUMBER_IS_REQUIRED: 'Número es requerido',
          VP_ADDRESS_FLOOR_IS_REQUIRED: 'Piso es requerido',
          VP_ADDRESS_DEPARTMENT_NUMBER_IS_REQUIRED: 'Departamento es requerido',
          VP_ZIPCODE_IS_REQUIRED: 'Código postal es requerido',
          VP_LOCALITY_IS_REQUIRED: 'Localidad/Ciudad es requerido',
          VP_PROVINCE_IS_REQUIRED: 'Provincia es requerido',
          VP_COUNTRY_IS_REQUIRED: 'País es requerido',
          VP_ORGANIZATION_MODEL_IS_REQUIRED:
            'Modelo de organización es requerido',
          VP_HIREDATE_IS_REQUIRED: 'Fecha de ingreso/contratación es requerido',
          VISMA_PEOPLE_MEDIATOR:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          VISMA_PEOPLE_INVALID_POST_VALUES_MEDIATOR:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          EXTERNAL_API_COULD_NOT_CONNECT:
            'No se ha podido crear el usuario en Visma People. Intente nuevamente en unos minutos',
          VISMA_PEOPLE_ADDITIONAL_DATA:
            'Se creó el usuario en Visma People pero con errores en alguno de sus campos. Puede terminar de completar la información dentro de Visma People.',
          VISMA_PEOPLE_POST_MEDIATOR_BAD_REQUEST: {
            InvalidDocumentIdentifier:
              'El formato del número de documento de identidad es incorrecto',
            EmployeeFoundWithSameDocumentAndSameFileNumber:
              'Se encontró un Empleado con el mismo tipo y número de Documento',
            FileNumberExists:
              'El Legajo está duplicado en VP, revisar los datos'
          },
          VISMA_PEOPLE_PUT_MEDIATOR_BAD_REQUEST: {
            InvalidDocumentIdentifier:
              'El formato del número de documento de identidad es incorrecto',
            EmployeeNotFoundWithFileNumberAndDocumentNumber:
              'El legajo enviado no coincide con los datos en VP, revisar los datos',
            EmployeeNotFound:
              'El DNI,CUIL o Legajo del usuario no coincide con la información existente en Visma People, por favor revise la información y actualice donde corresponda.'
          }
        }
      }
    },
    main_document_page: {
      document: {
        title_document: 'Documentos',
        search_document: 'Buscador de Documentos',
        subtitle_search_document:
          'Búsqueda de documentos en el legajo de tus colaboradores',
        publish: 'Publicación masiva',
        subtitle_publish: 'Enviar documentos masivamente a los colaboradores'
      },
      publish: {
        title_publish: 'Publicación',
        individual: 'Publicación Individual',
        subtitle_individual: 'Enviar un documento a un colaborador',
        generic: 'Publicación genérica',
        subtitle_generic:
          'Enviar un mismo documento masivamente a mas de un colaborador',
        signature_reminder: 'Recordatorio de firma',
        title_signature_reminder:
          'Enviar recordatorio de firma sobre los documentos pendientes'
      },
      forms: {
        title_publish: 'Formularios',
        publish_forms: 'Publicar Formularios',
        subtitle_publish_forms: 'Envia formularios a tus colaboradores',
        published_forms: 'Formularios publicados',
        subtitle_published_forms:
          'Consultas sobre los formularios enviados a tus colaboradores',
        config_forms: 'Configuración de formularios',
        subtitle_config_forms: 'Crear o modificar los formularios'
      },
      management: {
        title_management: 'Gestión',
        publish_title_management: 'Gestión de publicación',
        subtitle_publish_title_management:
          'Modificar estado de publicaciones realizadas',
        process_status: 'Estado de procesos',
        subtitle_process_status: 'Ver el estado de las publicaciones realizadas'
      }
    },
    publishDocuments: {
      title: 'Publicación de documentos',
      goBack: 'Volver',
      loaderTxt: 'Cargando vista previa...',
      configMassivePublish: {
        title: 'Publicación masiva de documentos',
        companyAlert: 'La publicación la vas a realizar en la empresa ',
        monthTitle: '¿A qué mes corresponde el documento?',
        monthContent:
          'Selecciona el mes que pertenece el documento que vas a disponibilizar a tus colaboradores. Disponible 1 mes hacia adelante y hasta 12 meses hacia atrás',
        monthSelect: 'Selecciona el mes',
        documentTypeTitle: '¿Que documento vas a enviarle a tu colaborador?',
        documentTypeContent:
          'Selecciona entre los distintos tipos de documentos cargados en el sistema para publicar',
        documentTypeSelect: 'Título de documento',
        documentProcessTitle:
          '¿Es necesario realizar algún proceso en los documentos?',
        documentProcessContent:
          'El documento final que va recibir tu colaborador requiere de algun proceso tales como division de pdf, rotación y firma de los documentos',
        documentProcessNone: 'Tengo los documentos listos para publicar',
        documentProcessNoneContent:
          'Los documentos ya están divididos y firmados externamente',
        documentProcessSplitSign: 'Necesito dividirlos y firmarlos',
        documentProcessSplitSignContent:
          'Vamos a realizar la división y aplicar la firma de la empresa en los documentos',
        documentProcessSplit: 'Necesito dividirlos',
        documentProcessSplitContent:
          'Vamos a dividir los documentos, luego puedes bajar un archivo comprimido para firmarlo externamente',
        documentProcessOnlySign: 'Necesito firmarlos',
        documentProcessOnlySignContent:
          ' Los documentos ya estan divididos externamente, vamos a realizar la firma de la empresa en la plataforma',
        sendEmailTitle:
          '¿Quieres recibir los resultados de la publicación por email?',
        sendEmailContent:
          'Luego de realizar la publicación vas a recibir en el correo ingresado un resumen con los resultados de la publicación',
        email: 'Email',
        sendEmailCollabTitle: '¿Quieres notificar a los colaboradores ?',
        sendEmailCollabContent:
          'Tus colaboradores van a recibir un email notificándoles de que tienen una nueva publicación para revisar',
        sendEmailCollabContentPush:
          'Si marcas la notificación PUSH el empleado recibirá un aviso en su celular si tiene la aplicación instalada y si concedió el permiso para ser notificado.',
        sendEmailCollabYes: 'Si, notificar colaboradores',
        sendEmailCollabNo: 'No',
        sendPushCollab: 'Incluir notificación push',
        btnNext: 'Siguiente',
        btnCancel: 'Cancelar',
        badgeNews: 'Próximamente',
        publish: 'Publicar',
        signAndPublish: 'Firmar y publicar',
        hasCertEnabled:
          'No tienes un certificado para firmar los documentos electrónicamente',
        noPermissionCert:
          'No tienes un certificado vigente para firmar los documentos electrónicamente.',
        emailCertEmptyRecipients:
          'No hay un usuario definido con certificado activo para firmar los documentos electrónicamente, por favor contacte con soporte.',
        noEmail:
          'El usuario con permisos para crear certificados no tiene un email asociado en el sistema.',
        hasFnParser:
          'Este documento tiene un proceso de captura que no admite el proceso de corte y firma',
        noSignPosition:
          'No tienes definido el posicionamiento de la firma del empleador',
        createCert: 'Crear certificado',
        contactAdmin: 'Contactar administrador',
        configSignPosition: 'Configurar firma empleador',
        sending: 'Enviando...',
        messageSent: 'Mensaje enviado',
        enterEmail: 'Ingresar email',
        hasSignRequired: 'Este documento requiere firma.',
        noSignRequired: 'Este documento no requiere firma.',
      },
      onlyPublish: {
        title: 'Carga de archivo',
        subtitle: 'Seleccione un archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el archivo .zip listo para ser publicado (ya cortado y firmado de manera externa).',
        label: 'Selecciona tu archivo',
        uploadingFile: 'Subiendo archivo',
        fileSizeExceded: 'El archivo no puede superar los 750 MB',
        wrongFiletype: 'El archivo debe tener extensión .zip',
        success: '<strong>{quantity}</strong> Documentos procesados',
        addEmail: 'El usuario <b>{userName}</b> es el responsable de generar el certificado. <br /><br /> ¿Quieres agregar la dirección de su email para notificarlo?',
        haveNoEmail: 'No dispongo el email, utilizaré otro medio de contacto',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        enterEmail: 'Ingresa el email',
        sizeKb:'1 Archivo ({size} KB en total)',
        sizeMb:'1 Archivo ({size} MB en total)',
        modal: {
          title: 'Publicación de documentos',
          title_container:
            '¿Estas seguro de que quieres publicar los documentos?',
          description:
            'Los documentos van a ser disponibilizados a tus colaboradores',
          cancel: 'Cancelar',
          confirm: 'Si, publicar'
        },

        modalCancel: {
          title: 'Eliminar documento',
          description: '¿Estás seguro que quieres eliminar el documento?',
          cancel: 'Cancelar',
          confirm: 'Si, eliminarlo'
        }
      },
      onlySign: {
        title: 'Carga de archivo',
        subtitle: 'Seleccione un archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el archivo .zip con los documentos dividos externamente, aplicaremos la firma para que lo puedas publicar',
        label: 'Selecciona tu archivo',
        uploadingFile: 'Subiendo archivo',
        fileSizeExceded: 'El archivo no puede superar los 750 MB',
        wrongFiletype: 'El archivo debe tener extensión .zip',
        success: '<strong>{quantity}</strong> Documentos procesados',
        modal: {
          title: 'Publicación de documentos',
          title_container:
            '¿Estas seguro de que quieres publicar los documentos?',
          description:
            'Los documentos van a ser disponibilizados a tus colaboradores',
          cancel: 'Cancelar',
          confirm: 'Si, publicar'
        },

        modalCancel: {
          title: 'Eliminar documento',
          description: '¿Estás seguro que quieres eliminar el documento?',
          cancel: 'Cancelar',
          confirm: 'Si, eliminarlo'
        },
        modalPreviewDocument: {
          title: 'Vista previa',
          buttonClose: 'Cerrar vista previa',
          loaderTxt: 'Cargando vista previa...'
        }
      },
      split_and_crop: {
        title: 'Carga de archivo',
        processedFiles: 'Archivos procesados',
        subtitle: 'Seleccione el archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el pdf sabana original</br>Lo dividiremos para que lo puedas firmar externamente y lo puedas publicar',
        label: 'Selecciona tu archivo pdf',
        uploadingFile: 'Subiendo archivo',
        wrongFiletype: 'El archivo debe tener extensión .pdf',
        proccessWait:
          'Este proceso puede demorar unos minutos<br>Puedes consultarlo en <strong><u><a href="{link}">Estado de procesos</a></u></strong>',
        documentsProcessed: 'Total de archivos divididos',
        howToSignDocuments: '¿Cómo firmo los documentos de manera digital?',
        howToSignDocuments_1_1: 'Descarga el Archivo ',
        howToSignDocuments_1_2:
          'Firma los documentos externamente de manera digital',
        howToSignDocuments_1_3: 'Carga el archivo .zip con los pdf firmados',
        preview: 'Previsualizar archivo',
        download_file: 'Descargar archivo',
        download_file_loader: 'Descargando',
        next: 'Siguiente',
        modalCancel: {
          title: 'Publicación de documentos',
          title_container: '¿Estás seguro que deseas cancelar la publicación?',
          description: 'Se perderán los documentos procesados',
          cancel: 'Cancelar',
          confirm: 'Aceptar'
        },
        modalPreviewDocument: {
          title: 'Vista previa',
          buttonClose: 'Cerrar vista previa',
          loaderTxt: 'Cargando vista previa...'
        }
      },
      split_crop_and_sign: {
        title: 'Carga de archivo y firma de documento',
        subtitle: 'Seleccione el archivo a procesar',
        description:
          'El archivo que vas a subir a la plataforma tiene que ser el pdf sabana original</br>Lo dividiremos y firmaremos en la plataforma',
        label: 'Selecciona tu archivo pdf',
        wrongFiletype: 'El archivo debe tener extensión .pdf',
        uploadingFile: 'Subiendo archivo',
        proccessWait:
          'Este proceso puede demorar unos minutos<br>Puedes consultarlo en <strong><u><a href="{link}">Estado de procesos</a></u></strong>',
        pdfSplited: 'PDFs Cortados',
        preview: 'Previsualizar archivo',
        goToList: 'Volver al listado',
        documentsProcessed: '<strong>{input}</strong> Documentos procesados',
        next: 'Firmar y publicar',
        modalCancel: {
          title: 'Eliminar documento',
          description: '¿Estás seguro que quieres eliminar el documento?',
          cancel: 'Cancelar',
          confirm: 'Si, eliminarlo'
        },
        modalSignAndPublish: {
          title: 'Firma electrónica',
          titleSelect: 'Seleccionar certificado de firma',
          description:
            'Para poder firmar esta publicación tienes que ingresar la contraseña del <strong>certificado electrónico</strong>',
          descriptionSelect:
            'Selecciona el certificado para firmar los documentos',
          buttonSelect: 'Seleccionar',
          advise:
            'Al confirmar tus documentos van a ser disponibilizados a tus colaboradores',
          selected: 'Certificado de firma seleccionado',
          changeCertificate: 'Cambiar de certificado',
          labelInput: 'Ingrese la contraseña',
          cancel: 'Cancelar',
          confirm: 'Confirmar',
          noCert: 'No se ha detectado un certificado de empresa para utilizar',
          SIGN_DOCUMENT_CERT_NO_EXISTS:
            'No tienes un certificado activo para realizar la publicación',
          SIGN_DOCUMENT_CERT_PASSWORD_INVALID: 'Contraseña incorrecta',
          SIGN_DOCUMENT_TAG_NOT_FOUND: 'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_TAG: 'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_TAG_PARAMETER_TYPE:
            'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_DOCUMENT_TYPE:
            'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_NOT_CREATED: 'Ocurrió un error, consulta con soporte'
        },
        modalPreviewDocument: {
          title: 'Vista previa',
          buttonClose: 'Cerrar vista previa',
          loaderTxt: 'Cargando vista previa...'
        }
      },
      configIndivualPublish: {
        title: 'Publicación individual',
        subtitle: 'Configuración inicial',
        inputCuil: {
          label: 'Cuil',
          question: '¿Cuál es el cuil del colaborador?',
          description:
            'Ingresa el cuil del colaborador al que quieres enviarle un documento'
        },
        inputPeriod: {
          label: 'Selecciona el periodo al que pertenece el documento',
          question: '¿A que mes corresponde el documento?',
          description:
            'Selecciona el mes que pertenece el documento que vas a disponibilizar a tus colaborador. ' +
            'Disponible 1 mes hacia adelante y hasta 12 meses hacia atrás'
        },
        inputDocumentType: {
          label: 'Selecciona un tipo de documento',
          question: '¿Qué documento vas a enviarle a tu colaborador?',
          description:
            'Selecciona entre los distintos tipos de documentos cargados en el sistema para publicar',
          noDocuments: 'No se encontró el documento',
          signMessage: {
            required: 'Este documento requiere firma',
            notRequired: 'Este documento no requiere firma'
          }
        },
        checkDocumentSign: {
          label: 'Incluir firma de la empresa',
          question: '¿Quieres firmar los documentos?',
          description:
            'El documento pasará primero por el proceso de firma en la que se le incorporará la firma de la empresa'
        },
        checkNotificationMail: {
          label: 'Enviar email',
          question: '¿Quieres notificar al colaborador?',
          description:
            'Tus colaborador recibirá un email y/o notificación push indicándole que tiene una nueva publicación para revisar'
        },
        checkPushNotification: {
          label: 'Enviar notificación push'
        },
        publishLoadDocument: {
          label: 'Selecciona tu archivo',
          question: 'Selecciona el archivo a enviar',
          description: 'Puedes utilizar los siguientes tipos de archivos',
          filePreview: 'Previsualizar archivo'
        },
        action: {
          cancel: 'Cancelar',
          publish: 'Enviar documento',
          publishAndSign: 'Firmar y publicar'
        },
        modal: {
          success: 'Publicación realizada con éxito',
          publicNew: '¿Quieres enviar otro documento a un colaborador?',
          description:
            'Puedes continuar realizando envíos de documentos a tus colaboradores',
          leave: 'Salir',
          publicOther: 'Publicar otro documento'
        },
        errors: {
          SYSTEM_API_INVALID_CUIL: 'El cuil es inválido',
          SYSTEM_API_NOT_CREATE_DIRECTORY: 'No se pudo crear el directorio',
          SYSTEM_API_FILE_EXISTS: 'El archivo ya existe',
          SYSTEM_API_NOT_CREATE_REGISTRY_CARGA:
            'No se pudo crear el registro de carga',
          SYSTEM_API_DOCUMENT_NOT_PUBLISHED:
            'El documento no pudo ser publicado',
          SYSTEM_API_NOT_SEND_NOTIFICATION: 'No se pudo enviar la notificación',
          SYSTEM_API_PARAMETER_NOT_EXPECTED:
            'Uno o varios parámetros son inválidos',
          SYSTEM_API_NOT_MOVE_FILE:
            'El archivo no pudo ser movido a la carpeta',
          SYSTEM_API_PARAMETER_REQUIRED:
            'Uno o varios parámetros son requeridos',
          PDF_FILE_PAGE_SIZE_EXCEPTION:
            'El tamaño de hoja del pdf no esta permitido para la publicación',
          SIGN_DOCUMENT_CANNOT_CREATE_DIRECTORY:
            'No se puede crear el directorio de procesos',
          SIGN_DOCUMENT_CANNOT_UNZIP_FILE:
            'No se puede descomprimir el archivo cargado',
          SIGN_DOCUMENT_CERT_HAS_EXPIRED:
            'El certificado se encuentra expirado',
          SIGN_DOCUMENT_CERT_PASSWORD_INVALID:
            'El password del certificado no es válido',
          SIGN_DOCUMENT_INVALID_OUTPUT_JSON:
            'No se puede obtener la ruta de la carpeta',
          SIGN_DOCUMENT_INVALID_OUTPUT: 'La salida programada no es válida',
          SIGN_DOCUMENT_INVALID_TAG_OUTPUT_STATUS:
            'El estado de salida de la tarea programada no es válido',
          SIGN_DOCUMENT_CERT_NO_EXISTS:
            'No tienes un certificado activo para realizar la publicación',
          SIGN_DOCUMENT_TAG_NOT_FOUND: 'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_TAG: 'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_TAG_PARAMETER_TYPE:
            'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_INVALID_DOCUMENT_TYPE:
            'Ocurrió un error, consulta con soporte',
          SIGN_DOCUMENT_NOT_CREATED: 'Ocurrió un error, consulta con soporte',
          '268': 'Este PDF se encuentra encriptado y no puede ser procesado'
        },
        signatureAlert: {
          message: 'No se encontró una configuración de firma para la empresa, por favor realizarla desde al configuración de carpetas',
          configButton: 'Configurar firma'
        },
      },
      configGenericPublish: {
        title: 'Publicación Genérica',
        subtitle: 'Configuración inicial',
        withOutConfig: 'No se encontró una configuración de firma para la empresa, por favor realizarla desde al configuración de carpetas',
        configSign: 'Configurar firma',
        sign:{
          required: 'Este documento requiere firma',
          notRequired: 'Este documento no requiere firma',
        },
        maxFileSize: 'El documento no debe superar los 1MB',
        fileType: 'El tipo de documento no es permitido. Deberá ser PDF.',
        sendDocument: '¿Estás seguro que quieres enviar el documento?',
        cancel: {
          question: '¿Estas seguro que quieres salir de la publicación?',
          message: 'Al salir el documento y la información ingresada se eliminará',
        },
        confirmOut: 'Sí, salir',
        okMessage: 'Entendido',
        inputDocumentType: {
          label: 'Selecciona un tipo de documento',
          question: '¿Qué documento vas a enviarle a tus colaboradores?',
          description:
            'Selecciona entre los distintos tipos de documentos cargados en el sistema para publicar',
          noDocuments: 'No se encontró el documento'
        },
        inputSector: {
          title: 'Sector',
          label: 'Selecciona un sector',
          question: 'Selecciona sector, locación o cargo',
          description:
            'Selecciona el sector, la locación y el cargo de quienes van a recibir este documento',
          clear: 'Limpiar selección',
          noResult: 'No hay sectores',
          required: 'Este campo es requerido'
        },
        inputLocation: {
          title: 'Locación',
          label: 'Selecciona una locación',
          clear: 'Limpiar selección',
          noResult: 'No hay locaciones',
          required: 'Este campo es requerido'
        },
        checkNotificationMail: {
          label: 'Enviar email',
          question: '¿Quieres notificar al colaborador?',
          description:
            'Tus colaboradores recibirán un email notificándoles de que tienen una nueva publicación para revisar'
        },
        publishLoadDocument: {
          label: 'Selecciona tu archivo',
          question: 'Selecciona el archivo a enviar',
          description: 'Puedes utilizar los siguientes tipos de archivos',
          filePreview: 'Previsualizar archivo'
        },
        action: {
          cancel: 'Cancelar',
          publish: 'Enviar documento'
        },
        modal: {
          success: 'Publicación realizada con éxito',
          publicNew: '¿Quieres enviar otro documento a los colaboradores?',
          description:
            'Puedes continuar realizando envíos de documentos a tus colaboradores',
          leave: 'Salir',
          publicOther: 'Publicar otro documento'
        },
        errors: {
          SYSTEM_API_PARAMETER_NOT_EXPECTED:
            'Uno o varios parámetros son inválidos',
          SYSTEM_API_PARAMETER_REQUIRED:
            'Uno o varios parámetros son requeridos',
          PDF_FILE_PAGE_SIZE_EXCEPTION:
            'El tamaño de hoja del pdf no esta permitido para la publicación',
          SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
            'El tamaño del pdf supera el permitido',
          SYSTEM_API_INVALID_LOCACION: 'La locación es inválida',
          SYSTEM_API_INVALID_SECTOR: 'El sector es inválido',
          SYSTEM_API_INVALID_SUBFOLDERID:
            'El id del tipo de documento es inválido',
          SYSTEM_API_NOT_CREATE_DIRECTORY: 'No se pudo crear el directorio'
        },
        inputCargo: {
          title: 'Cargo',
          label: 'Selecciona un cargo',
          clear: 'Limpiar selección',
          noResult: 'No hay cargos',
          required: 'Este campo es requerido'
        }
      },
      errors: {
        SYSTEM_API_WRONG_MIME_TYPE: 'El archivo tiene un formato inválido',
        SYSTEM_API_ZIP_SUSPICIOUS_FORMAT: 'El archivo ZIP tiene un formato sospechoso o inseguro',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_UNZIP_PDF_FILES:
          'Archivo inválido. No se puede descomprimir',
        PUBLISH_DOCUMENT_MASSIVE_ZIP_WAITING_PROCESSED:
          'Ya existe un ZIP esperando a ser procesado',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_DOCUMENTS_COUNTS:
          'Archivo inválido, por cada PDF debe haber un XML',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_UNZIP:
          'Archivo ZIP inválido, no se puede descomprimir',
        SYSTEM_API_INVALID_SUBFOLDERID: 'ID de subcarpeta inválido',
        PDF_FILE_PAGE_SIZE_EXCEPTION:
          'El tamaño de página del PDF no está permitido',
        SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
          'El archivo no puede superar los 750 MB',
        SIGN_DOCUMENT_CERT_NO_EXISTS:
          "En este momento no hay un certificado activo para la firma y publicación.<br><span class='text-base mt-4'>Por favor, para continuar, genera un nuevo certificado en la sección de Certificados de firma electrónica.</span>",
        ERROR_CANCEL_PROCESS:
          'Ocurrió un error eliminando el documento<br>Por favor contactate con soporte',
        PAGE_REQUESTED_NOT_FOUND:
          'La pagina que se quiere visualizar no se encuentra en el archivo',
        ERROR_PREVIEW_GENERAL:
          'Ocurrió un error inesperado<br>Por favor contactate con soporte',
        EMAIL_VALUE_IS_INVALID:
          'El correo electrónico ingresado no es válido',
      },
      modals: {
        notification: {
          title: 'Enviar documento',
          question: '¿Estas seguro que quieres enviar el documento',
          cancel: 'Cancelar',
          send: 'Enviar documento'
        },
        error: {
          title: 'Documento nuevo',
          ok: 'Entendido'
        }
      }
    },
    certificates: {
      title: 'Certificados de firma electrónica',
      createCert: 'Crear certificado',
      createAlertTitle:
        'Alcanzaste la cantidad máxima de certificados activos en la empresa.',
      createCertAlertSteps: 'Para crear uno nuevo puedes:',
      createCertAlertSteps_1: 'Expirar un certificado existente',
      createCertAlertSteps_2: 'Esperar al vencimiento de un certificado activo',
      newCertificate: {
        title: 'Datos requeridos para la creación del certificado',
        subtitle:
          'Completa los siguientes campos para generar el certificado para firmar electrónicamente.<br>El certificado es uno solo por empresa.',
        required: '* Todos los campos son obligarios',
        personalInfo: {
          title: 'Datos personales',
          subtitle:
            'Complete los campos correspondientes con sus datos personales',
          nameAndSurname: 'Nombre y Apellido',
          position: 'Cargo en la empresa',
          email: 'Email',
          dni: 'CUIL'
        },
        companyInfo: {
          title: 'Datos de la empresa',
          subtitle:
            'Complete los campos correspondientes con los datos de la empresa',
          name: 'Razón social',
          uniqueId: 'Identificador único de la empresa'
        },
        password: {
          title: 'Contraseña',
          subtitle: 'Reemplazar por política de contraseña por empresa',
          password: 'Ingrese contraseña',
          repeatPassword: 'Confirmar contraseña'
        },
        signView: 'Visualización de firma en documentos',
        signInfo:
          'El colaborador va a visualizar la firma electrónica de la siguiente forma',
        signElectronic: 'FIRMADO ELECTRONICAMENTE',
        signName: 'NOMBRE Y APELLIDO',
        signCharge: 'CARGO',
        dni: 'CUIL',
        responsabilityTitle: 'Responsabilidad del uso de certificados',
        responsabilityLegend:
          'Entiendo que estoy habilitado para la creación de certificados por parte de la organización, y el resguardo de la contraseña generada queda bajo mi responsabilidad.',
        responsabilityCheckbox: 'Si, entendido',
        cancel: 'Cancelar',
        cancelQuestion: '¿Desea cancelar la creación del certificado?',
        cancelDataLost: 'Se perderán los datos ingresados.',
        accept: 'Aceptar',
        create: 'Crear certificado',
        successTitle: 'Certificado creado',
        successText: 'Certificado creado exitosamente',
        errors: {
          title: 'Ocurrió un error',
          '00026':
            'El password ya ha sido previamente usado, por favor coloca otro password e intenta de nuevo',
          '00141':
            'El password no cumple con la políticas de contraseña de la empresa, por favor verifica el password e intenta de nuevo',
          generic:
            'Ocurrió un error creando el certificado. Por favor contactate con soporte'
        },
        gotIt: 'Entendido'
      },
      emptyState: {
        title: 'Esto es un desierto...',
        noCert: 'No tienes un certificado activo para firmar los documentos',
        noCert2: 'No hay documentos nuevos en tu bandeja de tareas',
        createCert:
          'Para crear uno nuevo presiona el botón <strong>Crear certificado</strong>'
      },
      certificatesList: {
        activeTitle: 'Certificado activo',
        expiredTitle: 'Certificados expirados',
        createdBy: 'Creado por <strong>{input}</strong>',
        creationDate: 'Fecha creación <strong>{input}</strong>',
        validDate: 'Válido hasta {input}',
        expiredDate: 'Expirado {input}',
        btnCertificate: 'Ver certificado',
        btnExpireCertificate: 'Expirar',
        certificateModal: {
          closeBtn: 'Cerrar',
          modalTitle: 'Vista del certificado',
          certExpired: 'Certificado expirado',
          certActive: 'Certificado activo',
          validDate: 'Válido hasta {input}',
          expiredDate: 'Expirado {input}',
          personalDataTitle: 'Datos personales',
          fullName: 'Nombre y Apellido',
          position: 'Cargo en la empresa',
          email: 'Email',
          companyDataTitle: 'Datos de la empresa',
          companyName: 'Razón social',
          companyCuit: 'Cuit'
        }
      },
      expireCertificate: {
        expireModalTitle: 'Expirar certificado',
        expireModalBodyTitle: '¿Estás seguro de expirar este certificado?',
        expireModalSubtitle:
          'El certificado quedará inactivo y no se podrá volver a utilizar.',
        errors: {
          COMPANY_CERT_ALREADY_EXPIRED: 'El certificado ya expiró',
          COMPANY_CERT_NOT_FOUND: 'No se encuentra el certificado'
        }
      }
    },
    employees: {
      administration: {
        error: {
          SYSTEM_API_INVALID_PROFILE_TYPE_ID:
            'ID no es un tipo de perfil no válido',
          SYSTEM_API_INVALID_CUIL: 'Cuil inválido',
          SYSTEM_API_PARAMETER_REQUIRED:
            'profileTypesId es un parámetro requerido',
          SYSTEM_API_WRONG_MIME_TYPE:
            'Formato de archivo incorrecto, el archivo cargado debe ser en formato .csv'
        },
        message: {
          error: 'No se procesó el archivo por los siguientes motivos',
          info: 'El proceso se ha completado pero con errores',
          success: '¡Proceso completado!',
          inserted: {
            label: 'Se actualizaron {quantity} usuarios de {total} usuarios.'
          },
          failed: {
            observation: 'No existe el usuario',
            label: 'Fallaron {quantity} usuarios de {total} usuarios.',
            link: 'Click para descargar el listado de fallas.'
          },
          inactive: {
            observation: 'El usuario está como inactivo',
            label: 'Usuarios inactivos {quantity} de {total} usuarios.'
          },
          duplicates: {
            observation:
              'Ya se actualizó un registro previo con este identificador',
            label:
              'Se detectaron {quantity} registros duplicados de los {total} usuarios informados.',
            link: 'Click aquí para descargar el listado de duplicados en el archivo.'
          }
        },
        profileIntegration: {
          title: 'Gestión perfiles de integración',
          subTitle: 'Gestión de perfiles',
          name: 'Perfiles de integración',
          step: {
            question: '1. Haz una lista de cuentas de usuario',
            description:
              'Crea un archivo CSV para armar la lista de usuarios. ',
            link: 'Puedes descargarte este ejemplo para llenar'
          },
          step1: {
            question: '2. Perfiles de integración',
            assign: 'Asignar',
            unassign: 'Quitar',
            noResult: 'No hay perfiles',
            add: 'Agregar'
          },
          step2: {
            question: '3. Subir archivo',
            selectFile: 'Seleccione un archivo'
          },
          help: '¿Necesitas ayuda?',
          toSaveAssign: 'Asignar perfil',
          toSaveUnassign: 'Quitar perfil',
          validFile: 'El archivo debe tener extensión .csv'
        }
      }
    },
    updateLogo: {
      saveButton: 'Guardar',
      cancelButton: 'Cancelar',
      modalConfirm: 'Confirmar',
      subtitle: 'Imagen cargada',
      title: 'Utilizado actualmente',
      header: 'Actualización de marca',
      newLogoPlaceholder: 'Logo nuevo',
      uploadingFile: 'Subiendo archivo',
      actualLogoPlaceholder: 'Logo actual',
      modalHeader: 'Confirmar actualización',
      inputPlaceholder: 'Seleccione un archivo',
      modalTitle:
        '¿Estás seguro de que quieres aplicar esta modificación de marca?',
      modalText:
        'Esta modificación afectará la marca de la empresa que visualizan todos tus colaboradores.',
      errors: {
        unauthorized: 'Acceso denegado',
        wrongType: 'El tipo de archivo no está permitido',
        parameterExpected: 'Se espera el parámatro "logo"',
        exception: 'El logotipo de la empresa no se puede guardar',
        maxSizeExceeded: 'El tamaño del archivo supera el límite permitido'
      }
    },
    updateColors: {
      header: 'Paleta de colores',
      title: 'Personaliza los colores de tu plataforma',
      description: 'Los cambios que realices a la paleta de colores se veran reflejados en la barra lateral, botones y en algunos detalles de la plataforma, sera visible para todos tus colaboradores.',
      subtitle: 'Colores base',
      subtitle2: 'Colores títulos',
      inputColor1: 'Color primario (Sidebar, botones)',
      inputColor2: 'Color secundario  ( Cuando el usuario ubica el cursor sobre el icono )',
      inputColor3: 'Color activo  ( Cuando la opción esta seleccionada )',
      inputTitle: 'Color primario (titulos)',
       iconTextDescription: 'Esto afecta el texto del menu lateral y el texto de los iconos',
       inconTextTitle: 'Color de texto en íconos',
      black: 'Negro',
      white: 'Blanco',
      restoreDefault: 'Restablecer colores de la plataforma',
      restoreDefaultDescription: 'Restablecer colores por defecto',
      cancelButton: 'Cancelar',
      saveButton: 'Guardar',
      modalHeader: 'Confirmar actualización',
      modalTitle: '¿Estás seguro de que quieres aplicar esta modificación a la paleta de colores?',
      modalText: 'Esta modificación afectara los colores que ven tus colaboradores en la plataforma',
      modalConfirm: 'Confirmar',
      previewHeader: 'Vista previa paleta de colores',
      previewClose: 'Cerrar',
      modalReturn: {
        title: '¿Deseas salir?',
        cancelQuestion: '¿Estás seguro que deseas salir?',
        cancelDataLost: 'Los cambios realizados se perderán.',
        cancel: 'No, continuar',
        accept: 'Sí, salir'
      },
      preview: 'Vista previa',
      validation: {
        required: 'Este campo es requerido',
        hexFormat: 'Solo se admite formato de color tipo HEX'
      }
    },
    main_bussines_page: {
      payroll: {
        title: 'Nómina',
        payrollConfig: 'Configuracion de la nómina',
        description: 'Permite habilitar funcionalidades de Nómina',
        config: {
          title: 'Funcionalidades de Nómina',
          subtitle: 'Configuración',
          formQuestion:
            '¿Quieres habilitar a tu colaborador a que pueda solicitar anticipos?',
          caption: 'Permitir que tu colaborador solicite anticipos de haberes',
          radioOk: 'Si permitir',
          radioNot: 'No permitir'
        },
        confirmModal: {
          title: 'Nómina',
          subtitle: 'Configuración de la nómina',
          confirmQuestion:
            '¿Estás seguro que quieres cambiar la configuracion de solicitud de anticipos?',
          cancel: 'Cancelar',
          confirm: 'Aceptar'
        }
      },
      business: {
        title_bussines: 'Empresa',
        folder_settings: 'Configuración de carpetas',
        subtitle_folder_settings:
          'Define las carpetas y el lugar donde se almacenarán los distintos documentos',
        news_billboard: 'Cartelera de noticias',
        subtitle_news_billboard:
          'Publica noticias en la pantalla inicial de tu colaborador'
      },
      workflow: {
        title_workflow: 'Flujo de trabajo',
        workflow_creation: 'Gestión de flujos',
        subtitle_workflow_creation:
          'Establece por quienes van a pasar los documentos para aprobarse',
        group_management: 'Gestión de grupos',
        subtitle_group_management:
          'Define como estarán compuestos los grupos de aprobadores',
        configuration: {
          create: 'Crear flujo de trabajo',
          title: 'Configuración',
          flow_name: {
            title: '¿Cuál es el nombre de este flujo de trabajo?',
            description:
              'El nombre te va a servir para identificar quienes son los involucrados en el orden de aprobación y los documentos, trata de que sea un nombre descriptivo',
            input_placeholder: 'Nombre del flujo de trabajo'
          },
          selection_approves: {
            title: 'Selección de aprobadores',
            description:
              'Por favor, selecciona los aprobadores del circuito de aprobación,\n' +
              'recuerda el orden seleccionado, será el mismo en el que van a ser aprobados',
            subsection_title: 'Orden de aprobación',
            select_placeholder: 'Busca o selecciona del listado',
            add_other_approves: 'Agregar otro'
          },
          selection_document: {
            title: 'Selección de documentos',
            description:
              'Por favor, selecciona los documentos que deberán pasar por el circuito de aprobación, dichos documentos no podrán ser utilizados en otro circuito',
            subsection_title: 'Documento',
            select_placeholder: 'Selecciona el tipo de documento',
            add_other_document: 'Agregar otro'
          },
          button_save: 'Guardar',
          button_cancel: 'Cancelar',
          button_cancel_alt: 'Si, salir',
          buttonBack: 'Volver',
          noDocuments: 'No se encontró el documento'
        },
        modals: {
          create: {
            title: 'Guardar flujo de trabajo',
            body: '¿Estás seguro que quieres guardar el Flujo de trabajo',
            var_body: '{name}?',
            body_success:
              'El flujo de trabajo con nombre {name} fue creado correctamente',
            body_error: 'Ocurrió un error al crear el flujo de trabajo',
            button_success: 'Cerrar'
          },
          destroy: {
            title: 'Salir de flujos de trabajo',
            body_title: '¿Estás seguro que quieres salir?',
            body: 'Puedes continuar con este flujo de trabajo en cualquier momento desde Gestión de flujos (se guardará como borrador )'
          },
          errors: {
            DOCUMENT_EXISTS_IN_WORKFLOW:
              'El documento existe en otro flujo de trabajo',
            INCORRECT_APPROVING_GROUP: 'El grupo aprobador es incorrecto',
            SYSTEM_API_WRONG_DATA_TYPE:
              'Los valores del tipo de dato son incorrectos'
          },
          disabled: {
            title: 'Desactivar flujo',
            body_title: '¿Estás seguro que quieres desactivar este flujo?',
            body: 'Este flujo se desactivará y no podrás utilizarlo',
            cancel: 'Cancelar',
            action: 'Desactivar'
          },
          groups: {
            title: 'Miembros del grupo',
            action: 'Cerrar'
          }
        },
        table: {
          title: 'Flujos creados',
          headers: {
            date: 'Fecha',
            actions: 'Acciones',
            modifiedby: 'Modificado por',
            status: 'Estado',
            groups: 'Grupos',
            nameWorkflow: 'Nombre del workflow'
          },
          badge: {
            cancelled: 'Cancelado',
            active: 'Activo'
          },
          tooltipGroup: 'Ver miembros del grupo',
          tooltipCancel: 'Desactivar flujo'
        }
      },
      notifications: {
        title_notifications: 'Configuración de notificaciones',
        welcome_email: 'Email de bienvenida',
        subtitle_welcome_email:
          'Envia un email a tus colaboradores con la bienvenida a la plataforma',
        Personalize_emails: 'Personalizar emails',
        subtitle_Personalize_emails:
          'Modifica la comunicaciones que va a recibir tu colaborador'
      },
      personalization: {
        title_personalization: 'Personalización',
        brand_update: 'Actualización de marca',
        subtitle_brand_update:
          'Puedes reemplazar la imagen corporativa en la plataforma',
        color_palette: 'Paleta de colores',
        subtitle_color_palette:
          'Selecciona o personaliza los colores de la plataforma'
      },
      other_settings: {
        title_other_settings: 'Seguridad',
        mfa: 'MFA doble autenticación',
        subtitle_mfa:
          'Establece si tus colaboradores tienen doble factor de autenticación',
        audit: 'Auditoría',
        subtitle_audit:
          'Realiza auditorías de las acciones realizadas en la plataforma',
        security_Center: 'Centro de seguridad',
        subtitle_security_center:
          'Gestiona los permisos de tus colaboradores en la plataforma',
        manager_management: 'Gestión de managers',
        subtitle_manager_management:
          'Gestionar perfil de manager y las carpetas que pueden visualizar'
      },
      onboarding: {
        title_onboarding: 'Onboarding',
        onboarding_settings: 'Configuración onboarding',
        subtitle_onboarding_settings:
          'Establece los datos que le vas a pedir a tu colaborador en el onboarding'
      },
      certificate: {
        title_certificate: 'Certificados',
        electronic_sign_cert: 'Certificados de firma electrónica',
        subtitle_electronic_sign_cert: 'Certificados de firma electrónica'
      },
      self_service: {
        title_self_service:
          'Gestión de autoservicio para datos del colaborador',
        data_update: 'Actualización de datos',
        subtitle_data_update:
          'Habilita la opción para que tu colaborador actualice sus datos',
        bank_data: 'Datos bancarios',
        subtitle_bank_data:
          'Realiza auditorías de las acciones realizadas en la plataforma'
      }
    },
    cancelDocuments: {
      info: 'Los documentos seleccionados fueron anulados exitosamente',
      error: {
        GENERIC: 'No fue posible anular los documentos, intente mas tarde',
        MASSIVE_CANCEL_NONEXISTENT: 'Los ids no existen',
        MASSIVE_CANCEL_DUPLICATE: 'Hay ids duplicados',
        SYSTEM_API_PARAMETER_REQUIRED: 'Ids es un parametro requerido',
        SYSTEM_API_WRONG_DATA_TYPE: 'Valor de tipo de datos incorrecto - ids',
        SYSTEM_API_MAX_ARRAY_COUNT_EXCEEDED:
          'Se superó el número máximo de ids.'
      },
      heading: 'Anular documentos',
      title: '¿Estás seguro que quieres anular los documentos seleccionados?',
      content:
        'Solo se eliminarán los documentos seleccionados de la página actual',
      footer: {
        cancel: 'Cancelar',
        cancelled: 'Sí, anularlos'
      }
    },
    selfService: {
      taskManager: {
        contact: 'Datos de contacto',
        bank: 'Datos bancarios',
        identifies: 'Cómo me identifico',
        address: 'Cambio de domicilio',
        field: {
          cbuAlias: 'Número de cuenta',
          contactPerson: 'Persona de contacto de emergencia',
          contactType: 'Tipo de contacto',
          emergencyPhone: 'Teléfono de emergencia',
          personalPhone: 'Teléfono celular',
          personalPhoneHouse: 'Teléfono fijo',
          bank: 'Selecciona tu banco',
          bankAccountType: 'Tipo de cuenta',
          myNickName: 'Nickname',
          nameBank: 'Banco',
          cbu: 'Número de cuenta',
          copy: 'Copiar Número de cuenta',
          download: 'Descargar',
          myName: '¿Cómo quieres que te llamemos?',
          myLastName: 'Cuál es tu apellido',
          myGenre: 'Género',
          country: 'País de residencia',
          state: 'Provincia / Estado',
          city: 'Ciudad',
          street: 'Calle',
          addressNumber: 'Número',
          floor: 'Piso',
          department: 'Departamento',
          neighborHood: 'Barrio',
          blockStreet: 'Manzana',
          addressType: 'Tipo de domicilio',
          myAvatar: 'Foto actualizada',
          cci: 'Número de cuenta interbancaria',
          payment_type: 'Tipo de pago',
          account_number: 'Número de cuenta'
        },
        fieldsError: {
          nickName: {
            required: 'El Nombre es requerido',
            regex: 'Solo se admiten letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          },
          nameBank: {
            regex: 'Solo se admiten números y letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          },
          cbu: {
            regex: 'Solo se admiten números y letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          },
          typeAccount: {
            regex: 'Solo se admiten números y letras',
            min: 'No cumple con el mínimo de caracteres',
            max: 'Se superó el máximo de caracteres'
          }
        },
        fieldRequired: 'Este campo es requerido'
      },
      statusOk: 'La información del usuario se modificó con éxito',
      errors: {
        ACTION_ALREADY_EXISTS: 'Estás acciones ya existen',
        FAILED_SAVE_DATA:
          'No ha sido posible guardar la configuración, inténtelo de nuevo, es caso de permanecer el error, contacte a soporte',
        SYSTEM_API_PARAMETER_REQUIRED: 'Uno o varios parámetros son requeridos',
        SYSTEM_API_WRONG_DATA_TYPE:
          'Hay campos que contienen un valor de tipo incorrecto',
        EXPECTED_PARAMETER_VALUE: 'Uno o varios campos son requeridos',
        FAILED_DELETE_ACTION: 'Ocurrió un error al intentar eliminar el permiso',
        NOT_FOUND_FOLDER_CONFIG: 'No se encontró la configuración de carpeta para almacenar los documentos'
      },
      title: 'Actualización de datos',
      subTitle: 'Configuración',
      linkBack: 'Volver',
      linkCancel: 'Cancelar',
      linkSave: 'Guardar',
      linkSaveChanged: 'Guardar Cambios',
      linkSaveInformation: 'Guardar Información',
      linkDownloadPicture: 'Descargar foto',
      success: 'La configuración se guardó con éxito',
      isOk: 'Entendido',
      linkLeave: 'Sí, salir',
      leaveQuest: '¿Estás seguro de que quieres salir de la configuración?',
      radioOk: 'Si permitir',
      radioNot: 'No permitir',
      addressQuest:
        '¿Quieres habilitar a tu colaborador para que actualice su domicilio?',
      addressDescription:
        'Permitir que tu colaborador actualice su lugar de residencia, seleccionando país, ciudad y dirección',
      bankQuest:
        '¿Quieres habilitar a tu colaborador para que actualice sus datos bancarios?',
      bankDescription:
        'Permitir que tu colaborador actualice el banco en el que va a recibir su remuneración, puede seleccionar el banco e ingresar el cbu / alias',
      contactQuest:
        '¿Quieres habilitar a tu colaborador para que actualice sus datos de contacto?',
      contactDescription:
        'Permitir que tu colaborador actualice su teléfono de contacto y emergencia',
      identifiesQuest:
        '¿Quieres habilitar a tu colaborador para que actualice como se identifica (género)?',
      identifiesDescription:
        'Permitir que tu colaborador actualice como se percibe, podrá ingresar su nombre, apellido, género y una foto (opcional)',
      infoEmployee: {
        tab: {
          personalData: 'Datos personales',
          contactData: 'Datos de contacto',
          bankData: 'Datos bancarios',
          identificationData: 'Cómo me identifico',
          addressData: 'Datos de domicilio'
        }
      },
      whereToStoreDocument: '¿Dónde quieres almacenar el documento?',
      selectFolderForUpdateDocument:
        'Selecciona una carpeta donde se va a guardar el documento de actualización de domicilio del colaborador (declaración jurada)',
      whichTypeToStoreDocument: ' Selecciona tipo de documento',
      selectFolderError: 'Hubo un error en la configuracion de carpetas',
      selectFolder: 'Selecciona una carpeta',
      selectDocumentType: 'Selecciona un tipo de documento'
    },
    company: {
      welcomeEmail: {
        title: 'Email de bienvenida',
        subTitle: 'Este es el email que van a recibir tus colaboradores',
        description:
          'Aquí podras visualizar el contenido del email que van a recibir tus colaboradores en su casilla de correo registrada en la plataforma',
        actionCancel: 'Cancelar',
        actionSend: 'Envío mails de bienvenida',
        actionOk: 'Aceptar',
        actionBack: 'Volver',
        messageSended:
          'Se realizó el envío de mails a todos los usuarios que aún no han realizado el primer ingreso.',
        modal: {
          title: 'Envío mails de bienvenida',
          body: 'Estás a punto de envíar el mail de bienvenida a toda tu nómina activa, este proceso es de ejecución única ¿Desea continuar?'
        },
        errors: {
          WELCOME_EMAIL_ALREADY_USED:
            'La empresa ya realizó el envío de mails.',
          NOT_RESULT: 'No hay usuarios nuevos para enviar el mail.',
          INVALID_TOKEN: 'Token de autenticación no válido',
          DEFAULT_ERROR:
            'Ha ocurrido un error al intentar realizar el envío de mails.'
        }
      }
    },
    customEmails: {
      title: 'Personalizar emails',
      go_back_btn: 'Volver',
      template: {
        edit_btn: 'Editar',
        empty_email_template:
          'Próximamente podrás personalizar los emails correspondientes a esta sección.'
      },
      descriptionHeader: 'Este es el email que van a recibir tus colaboradores',
      description:
        'Aquí podrás visualizar el contenido del email que van a recibir tus colaboradores en su casilla de correo registrada en la plataforma',
      restoreDefault: 'Restablecer secciones por defecto',
      cancel: 'Cancelar',
      save: 'Guardar',
      edit: 'Editar',
      imgEdit: 'Editor de imagenes',
      imgDescription: 'Algunos datos que puedes utilizar de manera dinamica',
      restore: 'Restablecer',
      accept: 'Aceptar',
      emptyLibrary: 'Aún no existen imágenes en la librería',
      load: 'Cargar',
      library: 'Librería',
      errors: {
        COMPANY_GALLERY_LIMIT_EXCEPTION: 'Se excedió el limite de 20 imágenes',
        IMAGE_LIMIT_SIZE: 'El archivo no puede superar los 1 MB',
        IMAGE_TYPE: 'El archivo debe tener extensión .jpg, .png'
      },
      succesMessage: 'Carga exitosa',
      select_file: 'Seleccionar un archivo',
      cancelModal: {
        message:
          '¿Está seguro que desea cancelar la personalización de este email?',
        caption: 'Se perderán los datos ingresados.',
        confirmBtn: 'Si, cancelar',
        cancelBtn: 'No, continuar'
      },
      confirmModal: {
        message:
          '¿Está seguro que desea aplicar las modificaciones a esta plantilla de correo?',
        confirmBtn: 'Guardar',
        cancelBtn: 'Cancelar'
      },
      alertInformation:
        'Solo es posible cargar un máximo de 20 imágenes. No se podrán eliminar las mismas.',
      welcomeEmail: {
        welcome: '¡Bienvenid@ a',
        accessCreated: 'Hemos creado su usuario de acceso a la plataforma TuRecibo, donde podrás completar, firmar y visualizar todos los documentos laborales de {company}, en cualquier momento y desde cualquier lugar.',
        accessInfo: 'A continuación, compartimos la información necesaria para ingresar al sistema por primera vez, momento en el cual deberá realizar un cambio de su contraseña:',
        username: 'Usuario',
        password: 'Contraseña',
        enterSystem: 'Ingresar al sistema',
        regards: 'Saludos.',
        teamOf: 'Equipo de {company}',
        note: 'NOTA: Favor no responder este mensaje que ha sido generado automáticamente desde TuRecibo. Esta comunicación (incluidos sus anexos) contiene información confidencial, dirigida exclusivamente a su destinatario, quien deberá resguardar la confidencialidad. Queda prohibido la divulgación, modificación, reproducción o uso de la información aquí contenida por cualquier otra persona que no sea su destinatario'
      }
    },
    reports: {
      title: 'Reportes',
      graphs: {
        graphReceived: {
          title: 'Recibos totales - Últimos 12 meses',
          label: 'Recibos'
        },
        graphCompliant: {
          title: 'Recibos Conformes vs no conformes - Últimos 12 meses',
          labels: ['Conformes', 'No conformes'],
          label: 'Periodo de'
        },
        graphSigned: {
          title: 'Recibos firmados vs no firmados - Rango de periodos',
          labels: ['Firmados', 'No firmados'],
          fromPeriod: 'Desde',
          toPeriod: 'Hasta'
        }
      }
    },
    processManager: {
      title: 'Administrador de procesos',
      tableTitle: 'Consulta de estado de procesos',
      update: 'Actualizar',
      alias:{
        name: 'Nombre',
        lastName: 'Apellido',
        cuil: 'CUIL'
      },
      filters: {
        searchUser: 'Buscar usuario',
        noResults: 'No se encontraron Resultados',
        selectDate: 'Seleccione una fecha',
        search: 'Buscar',
        dateRangeRequired: 'Debe ingresar un rango de fechas',
        selectProcess: 'Seleccionar proceso' 
      },
      table: {
        empty: 'Sin resultados',
        inProgress: 'En progreso',
        withObservation: 'Completado pero con observaciones',
        withError: 'Error',
        withSuccess: 'Éxito',
        processed: 'Documentos procesados',
        canceled: 'Cancelado',
        continue: 'Continuar',
        user: 'Usuario',
        process: 'Proceso', 
        created: 'Creado',
        started: 'Iniciado',
        finished: 'Finalizado',
        status: 'Estado',
        of: 'de',
        itemsPerPage: 'Cantidad por página'
      },
      errors: {
        CUT_PARAMETERS_NOT_DEFINED:
          'No se encontraron las configuraciones necesarias para ejecutar el corte en el documento. ',
        CUT_AND_ROTATE_PARAMETERS_NOT_DEFINED:
          'No se encontraron las configuraciones necesarias para ejecutar el corte en el documento. ',
        ROTATE_PARAMETER_NOT_DEFINED:
          'No se encontraron las configuraciones necesarias para ejecutar el corte en el documento. ',
        DOCUMENTS_DIRECTORY_INVALID:
          'No se encontró la carpeta contenedora, proceso cancelado, por favor contacte a soporte.',
        CREATE_CERTIFICATE_DIRECTORY_ERROR:
          'No fue posible crear la carpeta para continuar con el proceso de firma, proceso cancelado, por favor contacte a soporte.',
        CREATE_OUTPUT_DIRECTORY_ERROR:
          'No fue posible crear la carpeta para continuar con el proceso de firma, proceso cancelado, por favor contacte a soporte.',
        CREATE_ZIP_OUTPUT_DIRECTORY_ERROR:
          'No fue posible crear la carpeta para continuar con el proceso de firma, proceso cancelado, por favor contacte a soporte.',
        CREATE_ZIP_FILE_ERROR:
          'Hubo un error al crear el archivo zip para la publicación. Por favor volver a intentarlo.',
        CERTIFICATE_NOT_FOUND:
          'No se encontró un certificado válido al momento de la firma, por favor reintentar.',
        CREATE_CERTIFICATE_FILE_ERROR:
          'No se pudieron generar los archivos del certificado electrónico para firmar los documentos, proceso cancelado, por favor contacte a soporte.',
        CREATE_PRIVATE_KEY_FILE_ERROR:
          'No se pudo crear la llave privada del certificado electrónico para firmar los documentos, proceso cancelado, por favor contacte a soporte.',
        SIGNATURE_PROCESS_ENDS_WITH_ERRORS:
          'Falló el proceso de firma de documentos, reintentar proceso.',
        SIGNATURE_POSITION_INVALID:
          'Se detectó una posición de firma inválida, por favor, configurar nuevamente la posición de firma desde el ABM de documentos, antes de reintentar el proceso.',
        INVALID_PASSPHRASE_FOR_SUPPLIED_PRIVATE_KEY:
          'Error al validar la llave privada de la contraseña del certificado, se debe reiniciar la publicación, proceso cancelado.',
        CERTIFICATE_IS_DISABLED:
          'El certificado seleccionado no se encuentra activo y es probable que haya expirado. Por favor intente con otro certificado o cree uno nuevo.'
      },
      modal: {
        title: 'Detalle de proceso',
        reportTo: 'Reporte enviado a',
        file: 'Archivo',
        period: 'Período',
        docQuantity: 'Numero de documentos procesados',
        docType: 'Tipo de documento'
      }
    },
    ManagerManagement: {
      title: 'Gestión de manager',
      subtitle: 'Perfiles disponibles',
      formQuestion:
        '¿Quieres habilitar el perfil de manager de manera automática y masiva?',
      caption:
        'Al habilitar el perfil de manager puedes seleccionar las carpetas que pueden visualizar en la plataforma. Por Ejemplo si no tienen que acceder a recibos de sueldo, destildar esa carpeta.',
      rbtDisable: 'No',
      rbtEnable: 'Si, habilitar',
      seeAllOptions: 'Ver todos',
      inputFolder: {
        title: 'Locación',
        label: 'Selecciona una carpeta',
        clear: 'Limpiar selección',
        noResult: 'No hay carpetas'
      },
      cancelModal: {
        title: 'Salir de gestión de manager',
        question: '¿Estas seguro que quieres salir de la gestión de manager?',
        caption: 'Los cambios realizados no se guardarán',
        cancelBtn: 'Cancelar',
        confirmBtn: 'Si, salir'
      },
      saveModal: {
        title: 'Guardar perfil manager',
        question:
          '¿Estas seguro que quieres guardar los cambios al perfil manager?',
        caption:
          'Este cambio va a afectar a {userCount} usuarios que ya tienen configurados filtros en el perfil de manager ',
        cancelBtn: 'Cancelar',
        confirmBtn: 'Guardar'
      },
      successMessage: 'Los cambios se guardaron correctamente.',
      errorMessage: 'Ocurrió un error.'
    },
    signatureReminder: {
      title: 'Recordatorio de firma',
      subtitle: 'Enviar recordatorio de documento no firmado',
      body: {
        title: 'Texto a enviar:',
        to: 'Estimado,',
        text: 'Le recordamos que cuenta con documentos puestos a disposición en la plataforma',
        text1: 'sin su firma.',
        regards: 'Desde ya agradecemos su colaboración.',
        desc: 'Notificación para {cant} usuarios con recibos sin firmar entre los períodos {lastPeriod} y {currentPeriod}',
        noReminder: 'No hay usuarios con recibos no firmados para notificar'
      },
      button: 'Enviar recordatorios'
    },
    documentDetail: {
      uploadTypes: {
        CM: 'Carga Manual',
        KO: 'Kofax',
        CD: 'Carga Masiva',
        EFORMS: 'Eforms'
      },
      title: 'Detalle de documento',
      buttonReport: 'Reporte Trazabilidad',
      buttonDownload: 'Descargar Documento',
      buttonDownloadXML: 'Descargar XML',
      buttonGoBack: 'Volver',
      empty: {
        title: 'Esto es un desierto...',
        content:
          'El eform se encuentra en proceso de generación. Una vez firmado el mismo se visualizará en esta sección',
      },
      emptyError: {
        title: 'Esto es un desierto...',
        content: 'No se pudo cargar el archivo',
        contentCancelled: 'No se pudo cargar el archivo porque el documento está Anulado'
      },
      comments: {
        title: 'Observaciones',
        buttonAddComment: 'Nueva observación',
        empty: {
          title: 'Esto es un desierto',
          content: 'No se han realizado observaciones en el documento',
        },
        deleteComment: 'Eliminar',
        modal: {
          title: 'Agregar observación',
          body: 'Observación',
          buttonAdd: 'Guardar',
          buttonCancel: 'Cancelar',
        },
        modalDelete: {
          title: 'Eliminar observación',
          buttonOk: 'Sí, eliminar',
          buttonCancel: 'Cancelar',
          body: '¿Estás seguro de que quieres eliminar la observación?',
          legend: 'La observación se eliminará. Esta acción no se puede deshacer.'
        }
      },
      dataFile: {
        title: 'Datos del archivo',
        filename: 'Nombre',
        origin: 'Origen',
        date: 'Fecha',
        id: 'ID'
      },
      document: {
        title: 'Documento',
        cuil: 'CUIL',
        type: 'Tipo',
        sector: 'Sector',
        location: 'Locación',
        status: 'Estado',
        edit: 'Editar',
        delete: 'Eliminar',
        reject: 'Anular',
        cancel: 'Cancelar',
        save: 'Guardar',
        modalCancel: {
          title: 'Anular documento',
          buttonOk: 'Sí, anular',
          buttonCancel: 'Cancelar',
          body: '¿Estás seguro de que quieres anular el documento?',
          legend: 'El documentos se anulará y despublicará. Esta acción no se puede deshacer.'
        },
        date: 'Periodo | Mes y Año'
      },
      sign: {
        title: 'Firma',
        date: 'Fecha',
        type: 'Tipo de Firma',
        finger: 'Finger Print',
        empty: {
          title: 'Esto es un desierto',
          content: 'No hay información de firma para este documento'
        }
      },
      information: {
        cuil: 'CUIL',
        entrydate: 'Fecha de ingreso',
        email: 'Email',
        sector: 'Sector',
        location: 'Locación',
        countsigned: 'Recibos firmados',
        countunsigned: 'Recibos no firmados',
        viewEmployeeProfile: 'Ficha del colaborador',
        copyEmail: 'Copiar Email',
        copiedText: 'Copiando email',
        empty: {
          title: 'Esto es un desierto...',
          content: 'No existe usuario asociado al {identificator} del documento'
        },
        data: 'Legajo de documentos',
        activity: 'Trazabilidad',
        register: 'Datos'
      },
      errors: {
        default: 'Ha ocurrido un error',
        'SYSTEM_API_PARAMETER_IS_EMPTY': 'Uno o más campos son requeridos',
        'SYSTEM_API_PARAMETER_REQUIRED': 'Uno o más campos son requeridos',
        'SYSTEM_ACTION_NOT_GRANTED': 'No tienes el permiso para realizar esta acción',
        'SYSTEM_API_WRONG_DATA_TYPE': 'Valor de campo incorrecto',
      },
      emptyDocument: {
        title: 'Esto es un desierto...',
        content:
          'El documento que no esta disponible',
      },
      commons: {
        cuil: "CUIL"
      },
      informationFile: {
        type: 'Tipo',
        detail: 'Detalle'
      }
    },
    searchEmployee: {
      notificationReminder: {
        notified: 'Notificados',
        notNotified: 'No notificados',
        totalNotified: 'Total notificados',
        download: {
          part1: 'Descargue el',
          part2: 'Reporte de notificaciones'
        },
        cancel: 'Cancelar',
        send: 'Enviar',
        accept: 'Aceptar'
      },
      tableStatus: {
        inactive: 'Inactivo',
        active: 'Activo',
        total: 'Total'
      },
      add: 'Agregar'
    },
    employeePanel: {
      sectionsTitles: {
        personalData: 'Datos personales',
        configuration: 'Configuración',
        onboarding: 'Onboarding',
      },
      changeTemplate: {
        currentTemplate: 'Plantilla actual',
        newTemplate: 'Nueva Plantilla',
        message: '      Al cambiar la plantilla se perderan todos los datos que haya cargado el empleado.',
        swal: {
          title: 'Está seguro que desea cambiar la plantilla?',
          message: 'Al cambiar la plantilla se perderan todos los datos que haya cargado el empleado'
        }
      },
      identifyGenre: {
        man: 'Hombre',
        woman: 'Mujer',
        noBinary: 'No binario',
        other: 'Prefiero no indicar'
      },
      fieldValidation: 'No se permiten guiones',
      importantTitle: 'Importante',
      noValidCuil: 'El CUIL no debe contener guiones.',
      userAccount: 'Cuenta Sueldo',
      userAccountCTS: 'Cuenta CTS',
      particularAddress: 'Particular',
      onboardingActivate: 'Activar Onboarding',
      errorDoc: 'Ocurrió un error al procesar el documento',
      errorDocMultiple: 'Ocurrió un error al procesar los documentos',
      requestDoc: 'Solicitar volver a cargar el documento.',
      requestDocMultiple: 'Solicitar volver a cargar los documentos.',
      buttonCancel: 'Cancelar',
      buttonRequest: 'Solicitar',
    },
    billboard: {
      dragItems: '(arrastra los elementos de un campo al otro para incluirlos)',
      placeholderTitle: 'Titulo',
      placeholderVideo: 'URL video',
      chars: 'Caracteres',
      total1: '/255',
      total2: '/1000',
      formats: 'PDF, JPG, JPEG, PNG',
      employeeNotify: 'Notificar via mail a los empleados',
      search: 'Buscar',
      table: {
        title: 'Título',
        status: 'Estado'
      },
      days_left: {
        many: 'Faltan',
        one: 'Falta',
        days: 'días',
        day: 'día'
      },
      empty_state: {
        title: 'Hoy no hay noticias vigentes',
        description: 'En esta sección podrás publicar videos, PDF, imágenes, etc.'
      },
      errors: {
        invalidUrl: 'La URL ingresada no es válida'
      }
    },
    filterBar: {
      formName: 'Nombre formulario',
      filters: 'Filtros',
      form: 'Formulario',
      selfService: 'Autogestión',
      status: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo',
      packages: 'Paquetes de envíos',
      select: 'Seleccione...'
    },
    notificationModal: {
      title: 'Publicación sin notificación a empleados',
      description: 'Estás por realizar realizar una publicación que',
      noNotify: 'no va a notificar a tus empleados',
      publishWithout: 'Publicar sin notificación',
      publishWith: 'Publicar con notificación'
    },
    completePublishModal: {
      title: 'Documento nuevo',
      question: '¿Quieres cargar otro documento?',
      description: 'Puedes cargar otro documento completando o ir al detalle',
      description2: 'del documento que subiste',
      uploadAnother: 'Cargar otro documento',
      goToDetail: 'Ir al detalle'
    },
    pickup: {
      title: 'Configuración de formulario digital',
      newForm: '+ Nuevo Formulario',
      error: 'Error:'
    },
  }
}
